// i18n — all user-facing strings + tooltip dictionaries for ES / EN.
// Firm names, internal model IDs and code identifiers stay in English.

export function detectBrowserLang() {
  if (typeof navigator === "undefined") return "en";
  const nav = (navigator.language || "en").toLowerCase();
  return nav.startsWith("es") ? "es" : "en";
}

export function makeT(lang) {
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
  return (key, vars = {}) => {
    let str = dict[key];
    if (str === undefined) str = TRANSLATIONS.en[key] ?? key;
    if (!vars || typeof str !== "string") return str;
    Object.keys(vars).forEach(k => {
      str = str.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
    });
    return str;
  };
}

export const TRANSLATIONS = {
  es: {
    // Fase 19 · referidos
    promo_ref_lead: "Descuento de referido",
    promo_ref_detail: "por {code} · en todos los planes",
    // Fase 19 · rebajas de verano
    promo_banner_lead: "Rebajas de verano",
    promo_banner_detail: "en todos los planes · hasta el 31 ago",
    promo_badge: "verano −{pct}%",
    promo_save: "ahorras {amt}",
    promo_first_month: "primer mes",
    promo_first_year: "primer año",
    // Fase 18 · pantalla "simulando"
    sim_kicker: "04 · simulando",
    sim_kicker_compact: "simulando",
    sim_title: "Ejecutando análisis de Monte Carlo",
    sim_subtitle: "bootstrap por bloques · números aleatorios comunes",
    sim_target: "objetivo",
    sim_limit: "límite",
    sim_start_capital: "capital inicial",
    sim_distribution: "distribución",
    sim_starting: "iniciando motor",
    sim_complete: "análisis completo",
    sim_stage_1: "generando trayectorias de precio",
    sim_stage_2: "remuestreo por bloques · block bootstrap",
    sim_stage_3: "detectando autocorrelación en la serie",
    sim_stage_4: "aplicando números aleatorios comunes (CRN)",
    sim_stage_5: "intervalos de confianza · doble bootstrap",
    sim_stage_6: "ejecutando rejilla de estrés 4×4",
    sim_stage_7: "estimando fracción de Kelly",
    sim_stage_8: "consolidando veredicto",
    app_title: "PROP · FORGE",
    app_subtitle: "monte carlo for prop firm challenges",
    app_tagline: "› monte carlo for prop firm challenges",
    live_badge: "LIVE · CLIENT-SIDE",
    meta_counter: "{firms} firmas · {plans} planes",

    // Tabs (Fase 15-16 · Bloque 1: 5 pestañas con keys semánticas)
    tab_firms: "FIRMS",
    tab_strategy: "STRATEGY",
    tab_lab: "LAB",
    tab_results: "RESULTS",
    tab_help: "HELP",
    tab_account: "CUENTA",
    // Fase 17B · Bloque 1 — Step navigation (steps ARE the navigation)
    stepnav_1: "Elige firma",
    stepnav_2: "Carga tu estrategia",
    stepnav_3: "Revisa tu Lab",
    stepnav_4: "Simula y decide",
    // Fase 17B · Bloque 2 — GuideDrawer
    guide_open_full: "📖 ver la guía completa · 10 min",
    guide_open_page: "abrir como página →",
    guide_drawer_kicker: "Guía · 10 min",
    guide_drawer_title: "Cómo usar Prop Forge",
    guide_drawer_aria: "Guía completa de Prop Forge",
    guide_drawer_close: "cerrar guía",
    // Fase 17B · Bloque 3 — Account v2
    account_open_aria: "Abrir cuenta",
    account_back: "← volver",
    account_plans_title: "Planes",
    account_current_badge: "tu plan actual",
    account_switch_annual: "Cambiar a Annual →",
    account_pro_cta: "Mejorar a Pro →",
    account_annual_cta: "Mejorar a Annual →",
    account_downgrade_hint: "Para cancelar o bajar de plan, usa Gestionar suscripción.",
    account_logout: "Cerrar sesión",
    account_section_yours: "Tu cuenta",
    account_section_manage: "Gestionar suscripción",
    account_section_manage_hint: "tarjeta, facturas, cancelar — portal seguro de Stripe",
    // Plan card features (4-5 each, coherent with /guide table)
    account_plan_free_price: "Gratis",
    account_plan_pro_price: "31€/mes",
    account_plan_annual_price: "199€/año",
    account_plan_free_features: '["Simulación Monte Carlo","22 firmas reales","Modo simple (gaussiano)","Sin exportaciones","Sin Stress test"]',
    account_plan_pro_features: '["Todo lo de Free","Bootstrap de datos reales","Stress test 4×4","Comparador hasta 4 cuentas","Exportaciones PNG + JSON"]',
    account_plan_annual_features: '["Todo lo de Pro","2 meses gratis","Sizing sweep avanzado","Modo Funded","Prioridad en soporte"]',
    tab_firms_title: "selecciona una firma",
    tab_firms_hint: "elige la firma y el tamaño de cuenta · o configura los parámetros a mano",
    tab_firms_epigraph: "22 firmas reales · 81 cuentas · reglas auditadas sep-2026",
    tab_strategy_title: "tu estrategia",
    tab_strategy_hint: "introduce los datos de tu backtest. si tienes un historial de P&L, usa el modo data — es lo más fiable",
    tab_lab_title: "tu estrategia a examen",
    tab_lab_hint: "análisis honesto, sin firma de por medio",
    tab_results_title: "resultados",
    tab_results_hint: "probabilidades calculadas a partir de tu estrategia",
    tab_results_empty: "primero ejecuta una simulación · pestaña 02",
    tab_help_title: "ayuda y glosario",
    tab_help_hint: "todos los términos explicados, ordenados por sección",

    // Fase 17 · Bloque 5 — Vista Cuenta
    account_title: "tu cuenta",
    account_hint: "tu plan, tu suscripción, gestionada desde aquí",
    account_loading: "cargando suscripción…",
    account_error: "no hemos podido cargar tu suscripción.",
    account_retry: "reintentar",
    account_plan_label: "Plan",
    account_status_label: "Estado",
    account_renewal_label: "Renovación",
    account_plan_free: "Free",
    account_plan_pro: "Pro",
    account_plan_annual: "Anual",
    account_status_active: "Activa",
    account_status_canceled: "Cancelada",
    account_status_past_due: "Pago pendiente",
    account_status_incomplete: "Incompleta",
    account_status_trialing: "En prueba",
    account_status_unpaid: "Impagada",
    account_renews_on: "Se renueva el {date}",
    account_cancels_on: "Termina el {date}",
    account_manage_btn: "Gestionar suscripción",
    account_portal_loading: "abriendo portal…",
    account_upgrade_btn: "Mejorar a Pro",
    account_no_sub_body: "Estás en el plan gratuito. Mejora a Pro o Anual desde la pestaña STRATEGY para acceder a todas las firmas, exportaciones, comparador y modo funded.",
    // Aliases for backwards compatibility — DO NOT REMOVE (some legacy components still reference them)
    tab_01: "FIRMS",
    tab_02: "STRATEGY",
    tab_03: "RESULTS",
    tab_04: "HELP",
    tab_01_title: "selecciona una firma",
    tab_01_hint: "elige la firma y el tamaño de cuenta · o configura los parámetros a mano",
    tab_01_epigraph: "22 firmas reales · 81 cuentas · reglas auditadas sep-2026",
    tab_02_title: "tu estrategia",
    tab_02_hint: "introduce los datos de tu backtest. si tienes un historial de P&L, usa el modo data — es lo más fiable",
    tab_03_title: "resultados",
    tab_03_hint: "probabilidades calculadas a partir de tu estrategia",
    tab_03_empty: "primero ejecuta una simulación · pestaña 02",
    tab_04_title: "ayuda y glosario",
    tab_04_hint: "todos los términos explicados, ordenados por sección",

    // Fase 15-16 · Bloque 1 — LabTab
    lab_tab_purpose: "Tu estrategia en abstracto — sin firma de por medio. Si aquí hay banderas rojas, ninguna firma las arregla.",
    lab_empty_title: "El Lab analiza tu historial real. Carga tus datos en STRATEGY para empezar.",
    lab_empty_cta: "→ ir a STRATEGY",

    // Fase 15-16 · Bloque 2 — ProgressStepper
    step_nav_1: "Elige firma",
    step_nav_2: "Carga tu estrategia",
    step_nav_3: "Revisa tu Lab",
    step_nav_4: "Simula",
    step_nav_5: "Decide",
    tabs_guide_button: "guía",

    // Fase 15-16 · Bloque 3 — TabCoach
    coach__show: "mostrar guía",
    coach__dismiss: "cerrar",
    coach__chamber__purpose: "Aquí eliges contra qué reglas vas a jugar.",
    coach__chamber__steps: '["Pulsa una firma y luego un plan (tamaño).", "Lee el resumen: target, drawdown, daily loss y fee.", "¿Dudas entre firmas? El Lab te dirá cuáles son compatibles contigo."]',
    coach__chamber__cta: "Siguiente: carga tu estrategia →",
    coach__strategy__purpose: "Aquí le das al simulador tu forma de operar.",
    coach__strategy__steps: '["Pega tu P&L diario o sube el CSV (también vale el formato europeo 1.234,56).", "Comprueba los \\"primeros valores leídos\\" y los avisos.", "¿Sin datos a mano? Pulsa \\"◇ cargar ejemplo\\" y prueba todo en 60 segundos."]',
    coach__strategy__cta: "Siguiente: revisa tu Lab →",
    coach__lab__purpose: "Tu estrategia a examen, antes de hablar de firmas.",
    coach__lab__steps: '["Mira el veredicto del edge: ¿real o indistinguible de la suerte?", "Apunta tu peor racha esperada — saberla evita abandonar el sistema en el peor momento.", "Abajo: las firmas compatibles con el drawdown que generas."]',
    coach__lab__cta: "Siguiente: simula contra tu firma →",
    coach__oracle__purpose: "Aquí está tu respuesta. Léela en este orden.",
    coach__oracle__steps: '["El veredicto de arriba te lo traduce; P·PASS y su confianza (IC) son la base.", "BANKROLL · 95%: lo que de verdad cuesta intentarlo en serio.", "Si activaste funded: el resultado típico es la MEDIANA, no la media."]',
    coach__oracle__cta: "Último paso: el checklist de decisión ↓",
    coach__business__purpose: "Aquí ves tu estrategia como negocio: muchas cuentas, un bankroll limitado y un año entero.",
    coach__business__steps: '["Elige la mezcla de cuentas (o carga un ejemplo) y ajusta el tamaño de cada una.", "Fija bankroll, reinversión y cuándo pasan a operar todas a la vez.", "Simula, mira la quiebra y el decil malo, y prueba el optimizador de mezcla."]',
    coach__business__cta: "Simular negocio ↓",

    // Fase 15-16 · Bloque 4 — Toast hints
    hint_go: "ir",
    hint_plan_selected: "✓ {firm} {plan} seleccionado · siguiente: carga tu estrategia (02)",
    hint_data_loaded: "✓ {n} días cargados · siguiente: revisa tu Lab (03)",
    hint_sim_done: "✓ Simulación lista · no te pierdas el checklist de decisión al final",
    hint_stress_margin: "stress completado · tienes colchón para ser humano",

    // Fase 15-16 · Bloque 5 — VerdictCard (traffic-light)
    verdict_green_headline: "Con tu forma de operar pasarías 1 de cada {oneInN} intentos — y comprar este challenge es rentable a largo plazo ({ev} esperados por intento).",
    verdict_green_line2: "Plan realista: presupuesta {attemptsMedian} intentos ({bankroll95} para ir casi sobre seguro).",
    verdict_green_line3: "Tiempo típico hasta pasar: {medianDays} días de trading.",
    verdict_amber_headline: "Pasarías 1 de cada {oneInN} intentos y el negocio sale rentable, pero por poco margen — un mal tramo de varianza o ejecutar algo peor puede comértelo.",
    verdict_amber_line2: "Plan realista: presupuesta {attemptsMedian} intentos ({bankroll95} para ir casi sobre seguro).",
    verdict_amber_line3: "Tiempo típico hasta pasar: {medianDays} días de trading.",
    verdict_amber_extra: "Mira el stress test y el sizing antes de decidir.",
    verdict_red_headline: "Con esta configuración pierdes dinero a largo plazo: cada intento te cuesta de media {ev}.",
    verdict_red_line2: "Antes de pagar nada: prueba un tamaño menor (sizing), otra firma (compatibles en tu Lab), o revisa las banderas de tu estrategia.",
    verdict_no_funded: "(EV calculado sin ciclo funded — actívalo para el número completo)",
    verdict_footnote: "Los números completos están debajo — esto es solo la traducción.",
    // Funded verdict (Bloque 5c)
    funded_verdict_negative: "Lo más probable es que la cuenta muera antes de retirar — pero {pp}% de las veces sacas al menos un payout, y eso sostiene el negocio.",
    funded_verdict_positive: "El caso típico ya retira dinero: mediana {medianNet} con {pp}% de probabilidad de al menos un payout.",

    // Fase 15-16 · Bloque 6 — Decision Checklist
    dc_title: "✓ ¿VOY O NO VOY?",
    dc_item_1: "Strategy Lab limpio",
    dc_item_2: "EV positivo (a largo plazo, es negocio)",
    dc_item_3: "Confianza decente del resultado",
    dc_item_4: "Bankroll asumible",
    dc_item_5: "Margen en stress test",
    dc_item_6: "Tiempo realista",
    dc_sub_lab_ok: "lab analizado · revisa las banderas en la pestaña LAB",
    dc_sub_lab_missing: "revisa tu Lab (03)",
    dc_sub_ev_bad: "EV de {ev} — pierdes dinero cada intento de media",
    dc_sub_ci_wide: "IC ancho · más datos lo afinarían",
    dc_sub_ci_none: "carga más datos para conocer la confianza del resultado",
    dc_sub_bankroll: "compara {br95} con tu presupuesto real",
    dc_sub_stress_run: "ejecuta el stress test ↑",
    dc_sub_stress_unlock: "desbloquéalo con Pro",
    dc_sub_stress_tight: "alguno de los márgenes es 0 — quedas justo",
    dc_sub_time: "mediana {d}d · P90 {p90}d: ¿te cuadra?",
    dc_footer: "Todo ✓ → adelante, y sabes a qué juegas. Algún ✗ → la herramienta acaba de ahorrarte el coste de descubrirlo pagando.",

    // Fase 15-16 · Bloque 7 — Paywall tease
    tease_ready: "Calculado con tus datos ✓",
    tease_cta: "Desbloquear con Pro →",
    tease_funded_line: "Tu EV de ciclo completo y tu probabilidad de cobrar al menos un payout están listos.",
    tease_stress_line: "Tu margen de degradación está calculado: cuánto puedes empeorar antes de perder dinero.",
    tease_sizing_line: "Tu tamaño óptimo para esta firma está calculado.",
    funded_teaser_title: "Resultado del ciclo funded",
    funded_teaser_computing: "Calculando lo que sucede después de pasar…",

    // Fase 15-16 · Bloque 8a — trade-level parser
    boot_trade_level: "{nTrades} operaciones → {nDays} días de trading",

    // Fase 15-16 · Bloque 8c — Simple presets
    preset_label: "perfiles",
    preset_tooltip: "Perfiles realistas para explorar sin datos propios. Ajusta lo que quieras después.",
    preset_1: "Scalper conservador",
    preset_2: "Scalper agresivo",
    preset_3: "Swing 1:2",
    preset_4: "Intradía equilibrado",

    // Fase 15-16 · Bloque 9 — Demo mode
    landing_demo_cta: "Ver demo (sin registro)",
    demo_banner: "Estás viendo el simulador con datos de ejemplo. Para usar tu propio historial:",
    demo_banner_cta: "→ regístrate gratis",

    // Fase 16B · Bloque 1 — Export guides
    exp__title: "¿Cómo exporto mis datos?",
    exp__tradovate__name: "Tradovate",
    exp__tradovate__steps: '["Entra en tu dashboard → pestaña Performance.", "Elige el rango de fechas y pulsa el icono de descarga (CSV).", "Sube ese archivo aquí tal cual — detectamos las columnas y agrupamos por día."]',
    exp__ninjatrader__name: "NinjaTrader 8",
    exp__ninjatrader__steps: '["Control Center → Trade Performance.", "Genera el informe del periodo y clic derecho → Export → CSV.", "Súbelo tal cual: una fila por operación es justo lo que esperamos."]',
    exp__metatrader__name: "MetaTrader 4/5",
    exp__metatrader__steps: '["Pestaña Historial → clic derecho → Informe (HTML o CSV).", "Si es HTML, ábrelo en Excel y guárdalo como CSV.", "Sube el CSV — leemos \\"Close Time\\" y \\"Profit\\" y agrupamos por día."]',
    exp__tradingview__name: "TradingView",
    exp__tradingview__steps: '["Panel de Paper Trading o tu broker conectado → History.", "Exporta el historial a CSV.", "Súbelo tal cual."]',
    exp__other__name: "Otro / a mano",
    exp__other__steps: '["Vale cualquier CSV con una columna de P&L (y opcionalmente fecha).", "O simplemente pega una lista: un resultado por línea.", "El formato europeo (1.234,56) también funciona."]',

    // Fase 16B · Bloque 4 — Password recovery
    auth_forgot_link: "¿olvidaste tu contraseña?",
    auth_back_signin: "← volver al login",
    auth_submit_forgot: "enviar enlace de recuperación",
    auth_reset_sent: "Te hemos enviado un enlace. Revisa tu bandeja (y el spam por si acaso).",
    reset_kicker: "RECUPERAR CONTRASEÑA",
    reset_title: "Define tu nueva contraseña",
    reset_new: "nueva contraseña",
    reset_confirm: "confirmar",
    reset_submit: "guardar y entrar",
    reset_too_short: "Mínimo 6 caracteres.",
    reset_mismatch: "Las contraseñas no coinciden.",
    reset_done: "✓ Contraseña actualizada. Redirigiendo al simulador…",

    // Fase 16B · Bloque 5 — Invite link
    invite_label: "invitar",
    invite_copied: "✓ copiado",
    invite_tooltip: "Comparte Prop Forge con otro trader",
    invite_share_text: "Prop Forge — calcula tu probabilidad real de pasar un challenge antes de pagarlo.",
    help_restart_guide: "reiniciar guía completa",

    btn_next_strategy: "siguiente: tu estrategia →",
    strategy_empty: "selecciona primero una firma en la pestaña firms",

    // Hero (legacy keys)
    hero_tagline: "monte carlo for prop firm challenges",
    hero_quote: "",
    hero_quote_cite: "",
    hero_quote_author: "",
    hero_firms: "firmas",
    hero_plans: "planes",

    step_1_title: "ELIGE UNA FIRMA",
    step_1_subtitle: "choose a firm",
    step_1_hint: "cada firma tiene sus propias reglas. elige la tuya.",
    step_2_title: "selecciona una cuenta",
    step_2_subtitle: "choose an account",
    step_2_hint: "elige el tamaño de cuenta que quieres evaluar",
    step_3_title: "TU ESTRATEGIA",
    step_3_subtitle: "your stats",
    step_3_hint: "las estadísticas de tu backtest",

    step_custom_title: "crea tu propia configuración",
    step_custom_subtitle: "custom config",
    step_custom_hint: "modo custom activo · edita cada parámetro",
    step_custom_body:
      "defines tu propia configuración desde cero · los valores por defecto corresponden a una cuenta típica de futuros de $50k (target 6%, trailing EOD 5%).\n\ntodos los campos están desbloqueados en el panel de la cuenta a la izquierda.",

    filter_all: "TODAS",
    filter_futures: "FUTUROS",
    filter_forex: "FOREX",
    filter_custom: "CUSTOM",

    custom_card_title: "CONFIGURACIÓN PROPIA",
    custom_card_desc:
      "cuando ninguna firma existente refleja tu realidad — define todas las reglas desde cero.",
    custom_card_cta: "abrir",

    welcome_title: "Cómo funciona",
    welcome_hide: "ocultar",
    welcome_show: "guía",
    welcome_lead:
      "Prop Forge calcula tu probabilidad real de pasar el challenge de cualquier prop firm. Para eso simula 10.000 intentos día a día con tus propios datos de trading.",
    welcome_flow_title: "3 pasos",
    welcome_flow_1: "Elige la firma y la cuenta que quieres evaluar",
    welcome_flow_2: "Introduce tus datos de trading (P&L o estadísticas)",
    welcome_flow_3: "Obtén tu probabilidad y el valor esperado del intento",
    welcome_flow_4: "",
    welcome_needs_title: "Qué necesitas",
    welcome_needs_1: "Un historial de tu P&L diario (csv o lista de números) — recomendado",
    welcome_needs_2: "O las estadísticas de tu backtest: win rate, ganancia/pérdida media",
    welcome_needs_3: "",
    welcome_needs_4: "",
    welcome_footer:
      "¿Nunca has hecho un backtest? Prueba con el botón 'load example' para ver cómo funciona.",

    section_pnl: "A · P&L DIARIO",
    section_mae: "B · MOVIMIENTO ADVERSO",
    section_mae_opt: "(opcional)",
    section_account: "C · CUENTA",
    section_sim: "D · SIMULACIÓN",

    calibrate_cta: "† calibrar desde CSV",

    field_wr: "win rate",
    field_mu_win: "μ ganancia",
    field_sigma_win: "σ ganancia",
    field_mu_loss: "μ pérdida",
    field_sigma_loss: "σ pérdida",
    field_tail_prob: "p(spike)",
    field_tail_mult: "mult. spike",
    field_mae_win: "mae win",
    field_mae_loss: "mae loss",
    field_n_sims: "trayectorias",

    field_capital: "capital",
    field_target: "target",
    field_dd_type: "tipo dd",
    field_dd_value: "dd $",
    field_floor_lock: "floor lock",
    field_daily_loss: "daily loss",
    field_dll_value: "dll $",
    field_dll_fatal: "dll fatal",
    field_consistency: "consistency",
    field_consistency_pct: "% (0-1)",
    field_consistency_type: "tipo",
    field_min_days: "días mín",
    field_max_days: "días máx",
    field_phases: "fases",
    field_fee: "fee",
    field_fee_type: "tipo fee",
    field_activation_fee: "activación",
    field_profit_split: "profit split",
    field_max: "máx",

    dd_type_trailing_eod: "Trailing EOD",
    dd_type_trailing_intraday: "Trailing Intraday",
    dd_type_static: "Static",

    floor_lock_none: "None",
    floor_lock_at_capital: "At capital",
    floor_lock_at_target: "At target",
    floor_lock_at_cap_plus_100: "Cap + $100",

    cons_vs_total: "vs total",
    cons_vs_target: "vs target",

    phases_1: "1 fase",
    phases_2: "2 fases",
    fee_one_time: "único",
    fee_monthly: "mensual",

    btn_run: "ejecutar simulación",
    btn_running: "simulando",
    btn_edit: "editar",
    btn_close: "cerrar",
    btn_reset_preset: "↺ resetear al preset",
    btn_add_compare: "＋ añadir a comparar  ({n}/4)",
    btn_compare_full: "‹ comparador lleno (4/4) ›",
    btn_compare_clear: "↺ vaciar",
    btn_run_all: "✦  EJECUTAR TODAS · {n}  ✦",
    btn_run_all_disabled: "‹ mínimo 2 firmas ›",
    btn_export_png: "↓ exportar · PNG",
    btn_export_json: "↓ exportar · JSON",
    btn_csv_upload: "† subir .csv",
    btn_csv_sample: "◇ cargar ejemplo",
    btn_csv_clear: "↺ limpiar",
    btn_csv_apply: "✦  APLICAR  ✦",
    btn_csv_close: "✕ cerrar",

    modified_badge: "◆ ALTERADO",
    popular_badge: "★ POPULAR",
    monthly_badge: "MENSUAL",
    overnight_badge: "◇ OVERNIGHT",
    two_phase_badge: "╳ 2·FASES",

    // results chapters
    reveal_tag: "results",
    reveal_title: "RESULTADOS",
    chart_chapter: "trayectorias",
    chart_chapter_title: "TRAYECTORIAS",
    ledger_chapter: "ledger",
    ledger_chapter_title: "TABLA DE RESULTADOS",

    kpi_p_pass: "P · PASS",
    kpi_p_pass_sub: "break-even: {x}% · por debajo, no es rentable",
    kpi_p_pass_help: "Probabilidad de superar el challenge con tu estrategia. Comparado con el break-even, te dice si la firma es rentable a largo plazo.",
    kpi_ev: "EV · EVAL (1 RETIRO)",
    kpi_ev_sub: "coste medio: {x}",
    kpi_ev_help: "Valor esperado neto por intento. Positivo = rentable; negativo = pierdes dinero a largo plazo.",
    kpi_p_dd: "P · DRAWDOWN",
    kpi_p_dd_sub: "fallo por drawdown",
    kpi_p_dd_help: "Probabilidad de fallar por superar el límite de drawdown.",
    kpi_p_timeout: "P · TIMEOUT",
    kpi_p_timeout_sub: "la cuenta expira sin pasar",
    kpi_p_timeout_help: "Probabilidad de que la cuenta expire por días máximos antes de alcanzar el target.",
    kpi_p_dll: "P · DLL",
    kpi_p_dll_sub: "fallo por daily loss",
    kpi_p_dll_help: "Probabilidad de fallar por superar el daily-loss limit fatal.",
    kpi_p_fail: "P · FALLO",
    kpi_p_fail_sub: "probabilidad agregada de fallo",
    kpi_p_fail_help: "Suma agregada de todas las formas de fallo.",
    kpi_mean_days: "DÍAS · PASS",
    kpi_mean_days_sub_ok: "mediana {x}d",
    kpi_mean_days_sub_none: "sin muestras PASS",
    kpi_mean_days_help: "Días de trading necesarios cuando logras pasar.",
    kpi_p90_days: "P90 DÍAS",
    kpi_p90_days_sub: "90% pasan antes",
    kpi_p90_days_help: "El 90% de los PASS ocurren en menos días que este percentil.",
    kpi_bankroll: "BANKROLL · 95%",
    kpi_bankroll_sub_ok: "{x} intentos",
    kpi_bankroll_sub_zero: "P(PASS) ≈ 0",
    kpi_bankroll_help: "Capital necesario para tener 95% de probabilidad de pasar al menos una vez.",
    kpi_median_attempts: "MEDIANA INTENTOS",
    kpi_median_attempts_sub: "hasta primer PASS",
    kpi_median_attempts_help: "Número de intentos al primer PASS (mediana geométrica).",

    chart_result_dist: "‡ DISTRIBUCIÓN DE RESULTADOS",
    chart_days_pass: "‡ DÍAS HASTA PASS",
    chart_days_fail: "‡ DÍAS HASTA FALLO",
    chart_cap_pass: "mediana {m}d · p90 {p90}d · truncado en p95",
    chart_cap_fail: "mediana {m}d · truncado en p95",
    chart_no_samples: "sin muestras",
    chart_empty: "◇ sin muestras",

    stat_p_pass: "probabilidad de pasar",
    stat_ev_net: "valor esperado neto",
    stat_br99: "bankroll al 99%",
    stat_att99: "intentos al 99%",
    stat_roi: "ROI por PASS",
    stat_split: "profit split",
    stat_footer:
      "› sims: {sims} · pass: {pass} · dd: {dd} · timeout: {to} · dll: {dll} · payout/pass: ",

    selected_plan_label: "› PLAN SELECCIONADO",
    summary_capital: "CAPITAL",
    summary_target: "TARGET",
    summary_dd: "DD",
    summary_fee: "FEE",
    summary_split: "SPLIT",

    account_summary_title: "LA CÁMARA — EN LENGUAJE LLANO",
    account_summary_intro: "reglas efectivas que el oráculo va a honrar",
    summary_objective: "objetivo · ganar {tgt} sobre {cap} ({pct}%)",
    summary_dd_static: "drawdown · estático de {dd} · floor fijo en {floor}",
    summary_dd_trailing_eod: "drawdown · trailing EOD de {dd}",
    summary_dd_trailing_intraday: "drawdown · trailing intradía de {dd} · se mueve con cada pico de equity",
    summary_floor_none: "el floor nunca se ancla · sigue subiendo con el equity",
    summary_floor_at_cap: "el floor se ancla en el capital inicial ({cap})",
    summary_floor_at_target: "el floor se ancla en capital + target ({level})",
    summary_floor_cap100: "el floor se bloquea permanentemente en capital + $100 una vez superas capital + DD + $100",
    summary_dll_fatal: "daily loss · {v} · FATAL (la cuenta falla al superarlo)",
    summary_dll_soft: "daily loss · {v} · no fatal (pausa el día, la cuenta sobrevive)",
    summary_dll_none: "sin daily loss limit",
    summary_cons_target: "consistency · {pct}% vs TARGET · si un día supera ese umbral del target original, el target efectivo sube",
    summary_cons_total: "consistency · {pct}% vs TOTAL · el PASS se bloquea si el mejor día > {pct}% del profit acumulado",
    summary_cons_none: "sin regla de consistency",
    summary_days_both: "mínimo {min} días · máximo {max} días",
    summary_days_min_only: "mínimo {min} días · sin límite máximo",
    summary_days_max_only: "sin mínimo · máximo {max} días",
    summary_days_none: "sin límites de días",
    summary_fee_onetime: "tributo · {f} único",
    summary_fee_onetime_act: "tributo · {f} único + {a} activación al pasar",
    summary_fee_monthly: "tributo · {f}/mes (escala con la duración del intento)",
    summary_fee_monthly_act: "tributo · {f}/mes + {a} activación al pasar",
    summary_split: "split · {pct}% de las ganancias",
    summary_phase2: "fase 2 · target {tgt} · equity se resetea al arrancar · min {min}d, max {max}",
    summary_phase2_nomax: "fase 2 · target {tgt} · equity se resetea al arrancar · min {min}d, sin máximo",

    warn_monthly_fee: "fee mensual · cada mes que tardes en pasar pagas {fee} más",
    warn_apex: "cuenta apex · 30 días calendario · sin reset · los fallos por tiempo cuentan como TIMEOUT",
    warn_topstep: "topstep no impone DLL · es configurable por el trader en TopstepX · actívalo en editar si quieres modelar un límite personal",
    warn_cons_vs_target: "consistency {pct}% vs TARGET · si un día supera ese umbral del target original, el target efectivo sube · no bloquea, endurece",
    warn_cons_vs_total: "consistency {pct}% vs TOTAL · el PASS se bloquea si el mejor día > {pct}% del profit acumulado · se desbloquea tradeando más días",
    warn_two_phase: "dos fases · no una · cruza la primera (target {t1}) para enfrentar la segunda (target {t2}) · la equity se resetea entre fases",
    warn_modified: "has modificado los valores del preset · la simulación usa tus valores, no los originales",

    empty_configure: "configura tu estrategia y pulsa ",
    empty_render_here: "sin resultados · ejecuta una simulación para ver los datos",
    loading_msg: "simulando {n} trayectorias",

    compare_rack_title: "COMPARADOR",
    compare_rack_slots: "{n}/4 firmas",
    compare_slot: "SLOT·{n}",
    compare_help: "ranking abajo · ganadores marcados en dorado",
    compare_results_title: "‡ COMPARACIÓN · RANKED BY EV",
    compare_results_sub: "misma estrategia aplicada a todas · la que da más EV gana",
    compare_col_rank: "RANK · PLAN",
    compare_col_ppass: "P · PASS",
    compare_col_ev: "EV / INTENTO",
    compare_col_cost: "COSTE MEDIO",
    compare_col_mean: "DÍAS MEDIOS",
    compare_col_p90: "P90 DÍAS",
    compare_col_br95: "BANKROLL 95%",
    compare_col_roi: "ROI / PASS",
    compare_winner_prefix: "★ GANADORA ·",
    compare_winner_ev: "· mejor EV: ",
    compare_winner_ppass: "· p(pass) ",
    compare_forging: "simulando {n} trayectorias",

    csv_title: "↓ CALIBRAR DESDE CSV",
    csv_help_1: "› pega un CSV con un valor de P&L por día (positivo = win, negativo = loss, 0 = skip)",
    csv_help_2: "› o sube un archivo · hay un ejemplo para probar",
    csv_col_label: "columna pnl",
    csv_skip_header: "saltar cabecera",
    csv_detected_title: "§ DETECTADO",
    csv_calibrated_title: "§ CALIBRADO",
    csv_samples: "muestras",
    csv_wins: "wins",
    csv_losses: "losses",
    csv_total: "total pnl",
    csv_avg_day: "avg día",
    csv_err_samples: "necesitas al menos 5 muestras P&L no cero.",
    csv_err_no_wins: "no se detectan días ganadores.",
    csv_err_no_losses: "no se detectan días perdedores.",
    csv_placeholder: "day,pnl\n1,438\n2,-194\n3,620\n...",
    csv_col_option: "{header} · {n} nums{neg}",
    csv_col_neg: " · con neg",

    footer_l1: "simulación educativa · datos verificados abril 2026",
    footer_l2: "las reglas pueden cambiar sin aviso · verifica siempre la web oficial antes de comprar",
    footer_l3: "esto no es asesoramiento financiero",

    size_prefix: "",
    configure_word: "› configurar",

    // Results section titles
    ledger_chapter_title_timing: "TIMING",

    // Glossary
    gloss_search_placeholder: "buscar término",
    gloss_a_title: "SIMULATION METHODS",
    gloss_b_title: "DRAWDOWN TYPES",
    gloss_c_title: "FLOOR LOCK",
    gloss_d_title: "CONSISTENCY RULES",
    gloss_e_title: "MAE",
    gloss_f_title: "METRICS OUTPUT",
    gloss_simple_name: "SIMPLE MODE · gaussian",
    gloss_simple_body:
      "genera P&Ls diarios con distribuciones normales separadas para días ganadores y perdedores. rápido, simple. asume que tus retornos siguen una curva de gauss — lo cual NO es cierto en trading real. subestima colas gordas (outliers).\n\n→ úsalo si solo tienes medias y desviaciones de tu backtest\n→ evítalo si tu estrategia tiene días extremos (NFP, FOMC, catalizadores)",
    gloss_bootstrap_name: "BOOTSTRAP MODE · empirical",
    gloss_bootstrap_body:
      "en lugar de asumir una distribución, toma muestras aleatorias de una lista de P&Ls diarios que tú pegas directamente de tu backtest. preserva la asimetría y las colas reales de tu estrategia. mucho más honesto matemáticamente.\n\n→ úsalo si tienes al menos 100 días de backtest reales\n→ requiere pegar los datos (txt, csv, una columna con números)",
    gloss_static_name: "STATIC DRAWDOWN",
    gloss_static_body:
      "el floor de pérdida máxima está fijo en capital − ddValue. nunca se mueve. el más permisivo. usado por FTMO, FundedNext CFD, FundingPips, The5%ers.\n\nejemplo: 100K con 10% DD → floor en 90K, siempre.",
    gloss_teod_name: "TRAILING EOD",
    gloss_teod_body:
      "el floor sube basándose solo en el balance al cierre del día. intraday puedes aguantar dips sin fallar. mucho más realista para trading humano. usado por Topstep, Tradeify, MFFU.\n\nejemplo: cierras el día en 52K (capital 50K, DD 2K) → floor sube a 50K. al día siguiente empiezas con 50K de colchón.",
    gloss_tintraday_name: "TRAILING INTRADAY",
    gloss_tintraday_body:
      "el floor sube tick-a-tick con los picos de equity, incluyendo ganancias no realizadas. el más estricto — te castiga por tener unrealized profit y no cerrarlo. usado por Apex Intraday, MFFU Rapid, TPT PRO.\n\nejemplo: a media mañana vas +3K unrealized → floor ya subió 3K. si devuelves esa ganancia, el floor queda arriba.",
    gloss_fl_none_name: "NONE",
    gloss_fl_none_body:
      "el floor nunca se ancla, sigue subiendo para siempre. topstep eval funciona así: tu DD trail nunca se relaja.",
    gloss_fl_cap_name: "AT_CAPITAL",
    gloss_fl_cap_body:
      "el floor para de subir cuando llega al capital inicial. a partir de ahí no puede bajar por debajo del punto de partida. usado en TPT, TradeDay, Leeloo, Earn2Trade.",
    gloss_fl_target_name: "AT_TARGET_LEVEL",
    gloss_fl_target_body:
      "el floor se ancla en capital + target (ej. 53K para un 50K con 3K de target). apex hace esto: una vez pasas eval, ya no te pueden tocar por debajo del target.",
    gloss_fl_cap100_name: "AT_CAPITAL_PLUS_100",
    gloss_fl_cap100_body:
      "el floor queda anclado en capital + $100 una vez el balance EOD supera capital + ddValue + 100. tradeify, fundednext, mffu, phidias. modelo \"margen de cortesía\".",
    gloss_cons_target_name: "VS_TARGET · estilo topstep",
    gloss_cons_target_body:
      "si un día ganas más del X% del target original, el target EFECTIVO sube a (bestDay / X%). no bloquea el PASS, lo endurece.\n\nejemplo topstep 50K (target 3K, consistency 50%): si un día haces +2K, el nuevo target efectivo es 4K (2K / 0.5).",
    gloss_cons_total_name: "VS_TOTAL · estilo fundednext",
    gloss_cons_total_body:
      "el PASS se bloquea mientras tu mejor día supere el X% del profit acumulado. para desbloquearlo, sigues trading hasta diluir el peso de ese día.\n\nejemplo MFFU 50K (consistency 40%): si tu mejor día es 2K y llevas 3K acumulado, tu ratio es 67% → bloqueado. necesitas seguir ganando hasta que tu mejor día sea ≤ 40% del total.",
    gloss_mae_name: "MAE · maximum adverse excursion",
    gloss_mae_body:
      "MAE es la pérdida máxima unrealized que tuviste durante un día antes de cerrar. si cerraste +500 pero a media mañana ibas -300 en tu posición abierta, tu MAE fue 300.\n\nen trailing intraday DD, el MAE sí mata la cuenta — aunque cierres positivo, si durante el día tocaste el floor, fallaste.\n\nsimple mode genera MAE con una distribución gamma (poco fiable). bootstrap mode puede leer MAE directamente si lo incluyes en tus datos (columna MAE en el CSV).",
    gloss_ppass_name: "P(PASS)",
    gloss_ppass_body: "probabilidad de que un intento termine pasando el challenge.",
    gloss_ev_name: "EV · expected value",
    gloss_ev_body: "valor esperado por intento: P(PASS) × payout − coste_medio. si EV < 0 pierdes dinero en el largo plazo.",
    gloss_breakeven_name: "BREAK-EVEN P(PASS)",
    gloss_breakeven_body: "probabilidad mínima de pasar para que el EV sea positivo. tu P(PASS) real debe superar este umbral.",
    gloss_bankroll_name: "BANKROLL 95% / 99%",
    gloss_bankroll_body: "dinero total necesario para tener 95% (o 99%) de probabilidad de pasar al menos una vez. asume intentos independientes.",
    gloss_days_name: "DAYS TO PASS",
    gloss_days_body: "distribución de días que tardas en pasar, cuando pasas. media, mediana, p90.",
    gloss_attempts_name: "ATTEMPT DISTRIBUTION",
    gloss_attempts_body: "cuántos intentos hasta el primer PASS. mediana geométrica.",

    // Strategy v2 — mode toggle
    mode_title: "MODE",
    mode_simple: "SIMPLE · gaussian",
    mode_simple_sub: "distribuciones normales sobre medias y desviaciones. rápido. asume colas gaussianas (no ciertas).",
    mode_bootstrap: "DATA · empirical (bootstrap)",
    mode_bootstrap_sub: "muestreo aleatorio de tus P&Ls reales. preserva asimetría y colas. lo más fiable si tienes ≥ 100 días.",
    mode_recommended: "RECOMENDADO",

    // Strategy sections
    section_pnl_v2: "TRADING DATA",
    section_mae_v2: "INTRADAY RISK · MAE",
    section_costs: "COSTS & COMMISSIONS",
    section_behavioral: "BEHAVIORAL MODEL",

    // Section descriptions (italic gray, shown under each collapsible title)
    section_pnl_desc: "Los datos de tu backtest · win rate, P&L de días ganadores y perdedores · base del cálculo",
    simple_info_title: "¿Cuándo usar este modo?",
    simple_info_body: "Si todavía no has hecho trading real ni tienes un historial de P&L diarios. Por ejemplo, si estás probando una idea sobre el papel y solo tienes números teóricos: 'creo que mi win rate sería del 40% y mis ganadores serían el doble que mis perdedores'.\n\nEste modo se inventa días simulados a partir de esos números, asumiendo que siguen una campana de Gauss. Es una aproximación rápida pero menos fiable que el modo Data, que usa tus números literales sin inventarse nada.\n\nSi tienes al menos 30 días de trading real, usa el modo Data. Es más honesto.",
    section_mae_desc: "Máxima pérdida intradía antes del cierre · clave para drawdowns trailing-intraday",
    section_costs_desc: "Comisiones que erosionan tu P&L neto · ignóralo si tus datos ya son netos",
    section_behavioral_desc: "Qué cuentas como día válido y cómo cuentas los días máximos",
    section_postpass_desc: "Qué pasa después de pasar · ciclos de payout y consistency post-funded",

    // Section badges
    section_badge_advanced: "AVANZADO · OPCIONAL",
    section_badge_pro: "PRO · OPCIONAL",

    // Quick Start panel (above Trading Data)
    quick_start_title: "INICIO RÁPIDO",
    quick_start_body: "para una estimación rápida basta con rellenar la sección de TRADING DATA. el resto son ajustes avanzados opcionales — déjalos como están si no estás seguro.",

    // Bootstrap input
    bootstrap_help: "Pega los P&Ls de tu backtest · un número por línea, o CSV con columnas. También puedes subir un archivo .xlsx, .xls o .csv · acepta columnas: pnl, mae, mfe.",
    bootstrap_placeholder: "127\n-340\n892\n-45\n-210\n...\n\no bien:\ndate,pnl,mae\n2024-01-02,127,85\n2024-01-03,-340,420",
    bootstrap_parse: "parse data",
    bootstrap_paste_clip: "paste from clipboard",
    bootstrap_load_example: "◇ cargar ejemplo",
    bootstrap_upload_file: "↑ subir archivo",
    bootstrap_clear: "↺ borrar",
    bootstrap_loading: "Procesando...",
    bootstrap_drop_here: "Suelta el archivo aquí",
    bootstrap_error_format: "Formato no soportado. Sube un archivo .xlsx, .xls o .csv.",
    bootstrap_error_parse: "No se pudo leer el archivo. Asegúrate de que es válido.",
    bootstrap_error_empty: "El archivo está vacío o no tiene datos válidos.",
    bootstrap_excel_select_columns_title: "Asigna las columnas",
    bootstrap_excel_sheet: "hoja",
    bootstrap_excel_column: "Columna",
    bootstrap_excel_select_placeholder: "— Selecciona una columna —",
    bootstrap_excel_select_none: "— No tengo esta columna —",
    bootstrap_excel_preview: "Previsualización",
    bootstrap_excel_first_rows: "primeras filas",
    bootstrap_excel_confirm: "Confirmar",
    bootstrap_excel_cancel: "Cancelar",
    bootstrap_excel_label_pnl: "Columna de P&L",
    bootstrap_excel_help_pnl: "La ganancia o pérdida de cada día (positivo si ganas, negativo si pierdes).",
    bootstrap_excel_label_mae: "Columna de MAE",
    bootstrap_excel_help_mae: "Maximum Adverse Excursion: la mayor pérdida no realizada que llegaste a tener intradía antes de cerrar.",
    bootstrap_excel_label_mfe: "Columna de MFE",
    bootstrap_excel_help_mfe: "Maximum Favorable Excursion: la mayor ganancia no realizada que llegaste a tener intradía antes de cerrar.",
    bootstrap_excel_too_few_values: "Solo hay {count} valores numéricos. Mínimo recomendado: 30.",
    optional: "opcional",
    bootstrap_summary_title: "DATA SUMMARY",
    bootstrap_min_warning: "recomendado ≥ 100 · tienes menos muestras. los resultados serán ruidosos.",
    boot_no_mae_warning: "Tus datos no incluyen columna MAE. Las excursiones intra-día se estiman a partir de la distribución de tus PnL. Para máxima precisión con reglas de drawdown intra-día, incluye una columna MAE.",
    boot_preview_values: "Primeros valores leídos: {values}",
    survive_out_of_horizon: "El horizonte simulado es menor que esta ventana. Amplía el horizonte post-pass para medirla.",

    // MAE v2
    mae_help: "MAE = máxima pérdida unrealized durante el día antes de cerrar.",
    mae_estimate: "ESTIMATE (from instrument)",
    mae_manual: "MANUAL (direct values)",
    mae_auto: "AUTO (from bootstrap MAE column)",
    mae_auto_ok: "MAE se lee directamente de tus datos bootstrap.",
    field_instrument: "instrumento",
    field_mae_win_mean:  "μ MAE win",
    field_mae_win_std:   "σ MAE win",
    field_mae_loss_mean: "μ MAE loss",
    field_mae_loss_std:  "σ MAE loss",

    // Costs v2
    costs_help: "las comisiones erosionan el P&L neto. aplícalas si tus P&Ls son brutos (antes de fees).",
    costs_none: "NONE (P&L ya neto)",
    costs_estimate: "ESTIMATE (per contract × trades/day)",
    costs_fixed: "FIXED DAILY (cantidad plana)",
    field_comm_per_rt: "comisión por R/T",
    field_trades_day:  "trades por día",
    field_contracts_trade: "contratos por trade",
    field_daily_commission: "comisión diaria",

    // Behavioral v2
    behav_post_title: "POST-TARGET BEHAVIOR",
    behav_conservative: "CONSERVATIVE (realistic)",
    behav_conservative_sub: "al alcanzar target, si consistency bloquea, reducir tamaño al 30% para diluir sin riesgo.",
    behav_aggressive: "AGGRESSIVE (maximize speed)",
    behav_aggressive_sub: "mantiene el tamaño completo hasta pasar. más rápido, más fallos.",
    behav_mindays_title: "MIN DAYS COUNT",
    behav_mindays_total: "TOTAL TRADING DAYS",
    behav_mindays_winning: "WINNING DAYS ONLY (≥ $X)",
    field_win_day_threshold: "winning-day min $",
    behav_maxdays_title: "MAX DAYS TYPE",
    behav_maxdays_trading: "TRADING DAYS (~21/mes)",
    behav_maxdays_calendar: "CALENDAR DAYS (Apex)",

    // Oracle new
    chart_attempt_curve: "ATTEMPT CURVE · p(≥1 pass) vs number of attempts",
    chart_commission_impact: "COMMISSION IMPACT",
    comm_daily: "daily cost",
    comm_per_attempt: "per attempt",
    comm_pct_target: "% of target",

    // Glossary new sections
    gloss_g_title: "FUNDED LIFECYCLE",
    gloss_h_title: "OPERATIONS",
    gloss_attempt_curve_name: "ATTEMPT CURVE",
    gloss_attempt_curve_body: "curva que muestra la probabilidad acumulada de pasar al menos una vez tras N intentos. si tu P(PASS) individual es 30%, al 5º intento tu p(≥1 pass) ya es 83%. al 10º, 97%. útil para dimensionar bankroll a distintos niveles de confianza (50%, 75%, 95%, 99%).",
    gloss_funded_name: "FUNDED ACCOUNT",
    gloss_funded_body: "la cuenta real que recibes tras pasar el challenge. suele tener las mismas reglas de DD que el eval (pero no siempre). tu único objetivo post-PASS es acumular profit sin fallar, y pedir payouts cuando cumplas las condiciones de la firma. si fallas el DD, pierdes la cuenta y pagas un activation fee para rehacerla (si la firma lo permite).",
    gloss_payout_name: "PAYOUT",
    gloss_payout_body: "retirada del profit acumulado en la cuenta fondeada. cada firma define sus condiciones: mínimo N días tradeados, profit mínimo, pausa entre payouts. el trader recibe el % que marca el profit split (típico 80-90%). tras el payout, el balance se resetea al capital base en la mayoría de firmas.",
    gloss_takehome_name: "TAKE-HOME LIFETIME",
    gloss_takehome_body: "dinero neto total que esperas sacar de la vida útil de una cuenta fondeada, antes de ser reclamada por el DD. es la métrica que realmente importa — el P(PASS) solo es el primer escalón. una cuenta con P(PASS)=30% pero 4 payouts esperados antes de quemarse es mucho mejor que una con P(PASS)=50% pero solo 1 payout medio.",
    gloss_commissions_name: "COMMISSIONS",
    gloss_commissions_body: "las comisiones erosionan tu P&L neto cada día. para futuros NQ/ES ~$4 round-trip, CL ~$5, forex cero. si tus P&Ls de backtest son brutos (antes de fees), debes aplicarlas aquí — pueden comer 10-25% del target en scalpers intensivos. si ya son netos, déjalo en NONE.",
    gloss_behavioral_name: "BEHAVIORAL MODEL",
    gloss_behavioral_body: "modela cómo se comporta el trader cuando las reglas del challenge complican el PASS. conservative reduce size al 30% si target alcanzado pero consistency bloquea — dilluye sin riesgo. aggressive mantiene size y come más DDs. calendar-days suma weekends al contador de tiempo (Apex), afecta a TIMEOUTs.",
    gloss_autocorr_name: "AUTOCORRELATION WARNING",
    gloss_autocorr_body: "si tus datos bootstrap tienen autocorrelación alta (|ρ| > 0.2), los días consecutivos no son independientes (rachas de ganancias o pérdidas). nuestra simulación muestrea aleatoriamente — rompe esas rachas. los resultados pueden ser demasiado optimistas o pesimistas según el signo. en la práctica, una ρ entre -0.1 y +0.1 es ideal.",

    // ─── POST-PASS (FUNDED CYCLE) · ES ───
    section_postpass: "POST-PASS · FUNDED CYCLE",
    postpass_toggle: "Simular ciclo post-PASS (cuenta fondeada + payouts)",
    postpass_toggle_hint: "cuando PASS, seguimos simulando la cuenta fondeada hasta que breach o alcance el horizonte. extrae payouts según las reglas de la firma.",
    postpass_horizon: "Horizonte (meses)",
    postpass_horizon_hint: "ventana de simulación en meses de trading (~21d/mes).",
    postpass_size_title: "TAMAÑO POST-PASS",
    postpass_size_same: "MISMO TAMAÑO (realismo puro)",
    postpass_size_same_sub: "misma distribución que en eval · el trader mantiene su estilo.",
    postpass_size_reduced: "REDUCIDO (gestión conservadora)",
    postpass_size_reduced_sub: "aplica un factor al tamaño tras fondear — diluye riesgo a costa de velocidad.",
    postpass_size_factor: "Factor de size",
    postpass_rules_title: "REGLAS DE LA CUENTA FONDEADA",
    postpass_rules_hint: "pre-cargadas según la firma · puedes sobrescribir lo que quieras.",
    pp_firstPayoutMinDays: "Primer payout (días mín)",
    pp_payoutFrequency:    "Frecuencia entre payouts (días)",
    pp_payoutBuffer:       "Buffer de seguridad ($)",
    pp_payoutMinAmount:    "Payout mínimo ($)",
    pp_payoutMaxPct:       "% del profit retirable (0–1)",
    pp_payoutMaxCap:       "Cap por payout ($, opcional)",
    pp_safetyNet:          "Safety net ($)",
    pp_payoutConsistency:  "Consistency post-pass (0–1)",
    pp_payoutConsistencyType: "Tipo consistency post-pass",
    pp_resetOnPayout:      "Reset balance tras payout",
    pp_resetFloorOnPayout: "Reset floor tras payout",
    pp_ddTypeOverride:     "Override tipo de DD",
    pp_ddValueOverride:    "Override valor DD ($)",
    pp_floorLockOverride:  "Override floor lock",
    pp_dailyLossOverride:  "Override DLL ($, opcional)",
    postpass_reset: "Reset a defaults de firma",

    // ORACLE post-pass strings
    oracle_funded_title: "FUNDED LIFECYCLE · post-PASS",
    oracle_funded_hint:  "asumiendo que pasas el eval, ¿cuánto dinero netas y durante cuánto tiempo sobrevives?",
    kpi_pp_expected_net: "NET ESPERADO",
    kpi_pp_expected_net_sub: "tras profit split, horizonte {h}m.",
    kpi_pp_payouts: "PAYOUTS MEDIOS",
    kpi_pp_payouts_sub: "retiros completados en el horizonte.",
    kpi_pp_first_payout: "TIME TO 1ER PAYOUT",
    kpi_pp_first_payout_sub: "mediana en días de trading.",
    kpi_pp_survive3: "SIN BREACH · 3M",
    kpi_pp_survive6: "SIN BREACH · 6M",
    kpi_pp_survive12: "SIN BREACH · 12M",
    // Fase 14 · Bloque 1d: median hero + at-least-one payout
    kpi_pp_typical_outcome: "RESULTADO TÍPICO (MEDIANA)",
    kpi_pp_mean_inflated: "media (inflada por la cola derecha): {x}",
    kpi_pp_at_least_one: "P(≥1 PAYOUT)",
    kpi_pp_at_least_one_sub: "probabilidad de cobrar al menos una vez.",
    kpi_pp_at_least_one_tooltip: "Probabilidad de completar al menos un retiro antes del breach o del fin del horizonte.",
    // Fase 14 · Bloque 1a: seed UI
    seed_label: "seed",
    seed_rerun: "↺ nueva seed",
    seed_tooltip: "Misma seed + misma configuración = resultados idénticos. Cambia la seed para ver otra tirada del azar.",
    // Fase 14 · Bloque 3: block bootstrap UI
    block_sampling_notice: "muestreo: bloques de ~{L} días (tus rachas se preservan)",
    block_sampling_force_iid: "forzar días independientes",

    // Fase 14 · Bloque 4: Strategy Lab
    lab_title: "STRATEGY LAB",
    lab_empty: "Carga tu historial real para analizar tu estrategia.",
    lab_computing: "Analizando tu estrategia…",
    lab_section_edge: "Edge",
    lab_section_risk: "Riesgo",
    lab_section_growth: "Crecimiento",
    lab_section_robust: "Robustez",
    lab_expectancy: "expectancy/día",
    lab_significance: "veredicto",
    lab_edge_real: "Edge estadísticamente real (p={p})",
    lab_edge_luck: "Con {n} días, tu edge es indistinguible del azar (p={p})",
    lab_sqn_tooltip: "System Quality Number (Van Tharp): <1.6 pobre · 1.6-2 media · 2-3 buena · >3 excelente.",
    lab_sqn_poor: "pobre",
    lab_sqn_average: "media",
    lab_sqn_good: "buena",
    lab_sqn_excellent: "excelente",
    lab_worst_streak: "peor racha (días)",
    lab_streak_sub: "p50 · p90",
    lab_streak_tooltip: "Saberlo de antemano es la diferencia entre aguantar tu sistema y abandonarlo justo antes de que pague.",
    lab_underwater: "tiempo bajo el agua",
    lab_underwater_sub: "% de días por debajo del último máximo",
    lab_kelly_advice: "Arriesga como máximo ~{f}% de tu capital por día de pérdida media",
    lab_kelly_no_edge: "sin edge",
    lab_kelly_tooltip: "Kelly completo es agresivo; medio Kelly o menos es lo prudente. Si sale ≤0, no hay edge que apostar.",
    lab_split_ok: "Tus dos mitades son consistentes",
    lab_split_flag: "⚠ Tu primera mitad y tu segunda mitad parecen estrategias distintas (¿cambio de régimen o de sistema?)",
    lab_conc_ok: "Tu edge no depende de 3 días de suerte ({x} sin el top 3)",
    lab_conc_flag: "⚠ Sin tus 3 mejores días, tu estrategia pierde dinero ({x})",

    // Fase 14 · Bloque 5: Sizing sweep
    sizing_title: "Sizing óptimo · curva de tamaño",
    sizing_desc: "Mismo historial, distintos tamaños. Pequeño y no llegas al target; grande y el drawdown te ejecuta. Hay un punto óptimo — y depende de la firma.",
    sizing_run: "Ejecutar barrido de tamaño",
    sizing_running: "Calculando 7 escenarios…",
    sizing_only_bootstrap: "Disponible solo en modo con tus datos (bootstrap).",
    sizing_current_label: "tu tamaño actual (1×)",
    sizing_summary_html: "Tu punto óptimo de EV: <strong>{k}× tu tamaño histórico</strong> (P·PASS {p}%, EV {ev}). A 1×: P·PASS {p1}%.",
    sizing_disclaimer: "asume escalado lineal del PnL con el tamaño (válido para multiplicadores moderados)",
    sizing_tooltip: "Asume que tu PnL escala linealmente con el tamaño — válido para multiplicadores moderados; con tamaños grandes el slippage rompe la linealidad.",

    // Fase 14 · Bloque 6: CRN compare note
    compare_crn_note: "comparación con secuencias idénticas de azar (CRN) — las diferencias son solo de las reglas · seed {n}",

    // Fase 14 · Bloque 7: Compatible firms
    compat_title: "FIRMAS COMPATIBLES CON TU ESTRATEGIA",
    compat_tooltip: "Comparamos el límite de drawdown de cada plan con la distribución del max DD que TU estrategia genera en 30 días (a tu tamaño actual). Verde no garantiza pasar: garantiza que el límite no te queda pequeño.",
    compat_green: "holgura al 90%",
    compat_amber: "justa: holgura solo al 50%",
    // Fase 14 · Bloque 8: Guide entry links
    footer_guide_link: "Guía de uso",
    help_guide_banner: "¿Primera vez con Prop Forge? Hay una guía paso a paso de 10 minutos.",
    help_guide_cta: "Leer guía",

    compat_red: "tu DD típico supera su límite",
    kpi_pp_lifetime_ev: "EV · CICLO COMPLETO",
    kpi_pp_lifetime_ev_tooltip: "Valor esperado real con payouts simulados durante el horizonte: P(PASS) × media del net extraído − coste medio. Difiere del EV · EVAL porque incluye múltiples retiros antes del breach.",
    kpi_pp_lifetime_ev_sub: "P(PASS) × net esperado − coste medio.",
    kpi_pp_breach_dd: "breach por DD",
    kpi_pp_breach_dll: "breach por DLL",
    kpi_pp_no_breach: "sin breach",
    kpi_pp_p10p90: "p10 / p90 net",
    chart_pp_payout_hist: "DISTRIBUCIÓN DE NET TOTAL ($)",
    chart_pp_payout_count: "DISTRIBUCIÓN DE Nº DE PAYOUTS",
    chart_pp_by_month: "NET MEDIO POR MES",
    oracle_pp_empty: "Activa 'POST-PASS · FUNDED CYCLE' en STRATEGY para ver estas métricas.",

    // Glossary new (post-pass)
    gloss_postpass_name: "CICLO POST-PASS",
    gloss_postpass_body: "una vez pasado el eval, la cuenta fondeada sigue con reglas de DD/DLL activas. el simulador proyecta N meses, aplica payouts según el ritmo de cada firma y cuenta si el DD te echa antes de llegar al horizonte. las métricas clave son: NET esperado (tras split), nº de payouts, P(supervivencia) a 3/6/12 meses, y breach-rate.",
    gloss_safetynet_name: "SAFETY NET",
    gloss_safetynet_body: "cantidad de profit que debes acumular antes de poder retirar sin restricciones (Apex). hasta alcanzarlo, los payouts están capados.",
    gloss_consistency_postpass_name: "CONSISTENCY POST-PASS",
    gloss_consistency_postpass_body: "algunas firmas aplican consistency rule en la cuenta fondeada (Topstep 50%, MFFU 40%, TPT 20%). si la violas, no puedes retirar — aunque tengas profit disponible.",

    // IGNITE button disabled-state hints
    hint_no_chamber:       "selecciona primero una firma y una cuenta en la pestaña firms",
    hint_bootstrap_empty:  "modo bootstrap activo · pega tus datos de backtest en la sección P&L",
    hint_bootstrap_too_few:"necesitas al menos 30 valores · llevas {n}",

    // Extra glossary terms
    gloss_winning_days_name: "WINNING DAYS",
    gloss_winning_days_body: "cuando una firma exige un mínimo de días tradeados, puede contar TODOS los días (total) o solo los ganadores (≥ $X). el modo 'WINNING DAYS ONLY' ignora los días planos/negativos, lo que suele alargar el camino hasta el PASS pero refleja mejor lo que algunas firmas exigen internamente para validar la cuenta.\n\nejemplo: minDays=5 con winning-days y threshold $50 → necesitas 5 días con pnl ≥ $50, no solo 5 días de trading.",
    gloss_calendar_days_name: "CALENDAR vs TRADING DAYS",
    gloss_calendar_days_body: "el contador de máximo de días puede medirse en días de trading (~21/mes, ignora weekends) o en días de calendario (incluye weekends). Apex usa CALENDAR — es más estricto. FTMO usa TRADING — más permisivo.\n\nejemplo FTMO 100K (máx 30 trading days) vs Apex 50K EOD (máx 30 calendar days): aunque el número es idéntico (30), Apex te da ~21 días reales de trading efectivo, mientras FTMO te da ~42 días naturales para cerrar los 30 tradeables.",

    // Auth
    auth_sign_in: "iniciar sesión",
    auth_sign_up: "crear cuenta",
    auth_sign_out: "cerrar sesión",
    auth_email: "email",
    auth_password: "contraseña",
    auth_password_hint: "mínimo 6 caracteres",
    auth_submit_signin: "entrar",
    auth_submit_signup: "crear cuenta",
    auth_switch_to_signup: "¿no tienes cuenta? regístrate",
    auth_switch_to_signin: "¿ya tienes cuenta? inicia sesión",

    auth_check_email_title: "Revisa tu correo",
    auth_check_email_body_1: "Te hemos enviado un email de confirmación a {email}.",
    auth_check_email_body_2: "Haz click en el enlace del correo para activar tu cuenta. Si no lo encuentras, revisa la carpeta de spam o promociones.",
    auth_check_email_close: "Entendido",
    auth_error_invalid_email: "email no válido",
    auth_error_short_password: "la contraseña debe tener al menos 6 caracteres",

    // Paywall
    paywall_pro_feature: "función pro",
    paywall_current_plan: "tu plan actual: {plan}",
    paywall_upgrade_cta: "desbloquear",
    paywall_free_badge: "free",
    paywall_pro_badge: "pro",
    paywall_annual_badge: "anual",
    paywall_locked_firm: "firma bloqueada en plan free",
    paywall_upgrade_modal_title: "desbloquea prop forge",
    paywall_upgrade_modal_body: "con el plan pro accedes a las 22 firmas, el simulador de negocio, modo bootstrap, exportar, comparar y más",
    paywall_upgrade_monthly: "pro · 31€/mes",
    paywall_upgrade_annual: "Anual · 199€/año",
    paywall_period_yearly: "/año",
    paywall_close: "cerrar",

    // Coming soon (UpgradeModal footer)
    coming_soon_title: "Próximamente",
    coming_lab_title: "Strategy Lab",
    coming_lab_desc: "Diseña y backtestea tu estrategia con datos históricos. Integrado con Prop Forge.",
    coming_templates_title: "Plantillas TradingView",
    coming_templates_desc: "Scripts Pinescript listos: VWAP reclaim, NY open breakout, opening range...",
    coming_save_title: "Guardar configuraciones",
    coming_save_desc: "Guarda y comparte tus simulaciones favoritas con un link.",
    coming_mobile_title: "App móvil",
    coming_mobile_desc: "Consulta probabilidades desde tu móvil. Notificaciones push.",
    coming_soon_footer: "Los planes Pro y Anual incluyen acceso a todas estas features cuando se lancen.",

    // Stripe
    stripe_success_title: "¡Pago recibido!",
    stripe_success_body: "Bienvenido a {plan}. Desbloqueando tus features...",
    stripe_cancel_title: "Checkout cancelado",
    stripe_cancel_body: "No se ha realizado ningún cargo.",
    manage_subscription: "gestionar suscripción",
    stripe_loading: "procesando pago...",
    stripe_error: "error al procesar · intenta de nuevo",

    // Legal
    legal_terms: "términos",
    legal_privacy: "privacidad",
    legal_cookies: "cookies",
    legal_last_updated: "última actualización",
    legal_back_to_app: "← volver a la app",

    // Landing page
    landing_hero_title: "Calcula tu probabilidad real de pasar un challenge de prop firm",
    landing_hero_subtitle: "Simulación Monte Carlo basada en tus datos reales de trading. 22 firmas, 81 cuentas, sin asunciones mágicas. Y un simulador de negocio para ver muchas cuentas a la vez.",
    landing_hero_cta: "Calcular mi probabilidad",
    landing_hero_subhint: "Gratis para empezar · sin tarjeta de crédito",

    landing_how_title: "Cómo funciona",
    landing_step_1_title: "Elige tu prop firm",
    landing_step_1_desc: "22 firmas con sus reglas exactas (Apex, Topstep, Tradeify, Lucid, TakeProfit, FTMO, FundedNext…), auditadas en sep-2026 las principales de futuros.",
    landing_step_2_title: "Pega tus datos de trading",
    landing_step_2_desc: "Un csv con tu historial de P&L diario, o las estadísticas de tu backtest (win rate, ganancia/pérdida media).",
    landing_step_3_title: "Obtén tu probabilidad",
    landing_step_3_desc: "P(PASS), valor esperado por intento, bankroll necesario y días promedio para pasar.",

    landing_pricing_title: "Precios simples",
    landing_pricing_subtitle: "Empieza gratis. Paga solo si te aporta valor.",
    landing_price_forever: "Para siempre",
    landing_price_monthly: "/mes",
    landing_price_one_time: "Pago único",
    landing_free_feat_1: "3 firmas (Topstep, Phidias, FundingPips)",
    landing_free_feat_2: "Modo data y modo summary stats",
    landing_free_feat_3: "Resultados básicos: P(PASS), EV",
    landing_free_cta: "Empezar gratis",
    landing_pro_feat_1: "Las 22 firmas, 81 cuentas · reglas auditadas sep-2026",
    landing_pro_feat_2: "Configuración propia · define tus propias reglas",
    landing_pro_feat_3: "Simulador de negocio multi-cuenta + optimizador de mezcla",
    landing_pro_feat_4: "Comparar hasta 4 planes a la vez",
    landing_pro_feat_5: "Exportar resultados (json, png)",
    landing_pro_feat_6: "Guardar hasta 10 configuraciones",
    landing_pro_cta: "Elegir Pro",
    landing_price_yearly: "/año",
    landing_annual_feat_1: "Todo lo de Pro",
    landing_annual_feat_2: "Hasta 100 configuraciones guardadas",
    landing_annual_feat_3: "Acceso a futuras features cuando salgan",
    landing_annual_cta: "Elegir Anual",

    landing_faq_title: "Preguntas frecuentes",
    landing_faq_what_q: "¿Qué es Prop Forge?",
    landing_faq_what_a: "Una herramienta de simulación Monte Carlo que estima tu probabilidad real de pasar un challenge de cualquier prop firm. Introduces tus datos de trading reales o tus estadísticas de backtest, eliges la firma, y simulamos 10.000 trayectorias día a día con las reglas exactas de esa firma.",
    landing_faq_diff_q: "¿En qué se diferencia de otras herramientas?",
    landing_faq_diff_a: "La mayoría de calculadoras online te dan respuestas binarias o simulaciones simplificadas. Prop Forge usa el modelo bootstrap (con tus datos literales) o el modelo gaussiano completo, aplica las reglas exactas de cada firma (drawdown trailing, consistency rules, min/max days, dlls fatales, etc.), y te da resultados estadísticos rigurosos: P(PASS), valor esperado, bankroll necesario.",
    landing_faq_experience_q: "¿Necesito tener experiencia para usarlo?",
    landing_faq_experience_a: "No. Si nunca has hecho un backtest, puedes usar el botón 'load example' para cargar 200 días de datos de ejemplo y ver cómo funciona. Cada parámetro tiene una explicación contextual al hacer hover, y hay un glosario completo en la pestaña Help. Dicho esto, los resultados son tan buenos como los datos que introduces.",
    landing_faq_security_q: "¿Mis datos están seguros?",
    landing_faq_security_a: "Sí. Tus datos de trading nunca salen de tu navegador hasta que decides guardarlos. Las contraseñas se almacenan hasheadas (no las vemos), los pagos los procesa Stripe (nosotros no almacenamos tarjetas), y la base de datos está cifrada en MongoDB Atlas. Revisa nuestra política de privacidad para detalles.",
    landing_faq_cancel_q: "¿Puedo cancelar mi suscripción?",
    landing_faq_cancel_a: "Sí, en cualquier momento desde el portal de cliente (dentro de la app). La cancelación es inmediata y no se renueva la siguiente facturación. Mantienes acceso hasta el final del período pagado.",
    landing_faq_refund_q: "¿Hay reembolsos?",
    landing_faq_refund_a: "Al ser un producto digital de acceso inmediato, no ofrecemos reembolsos por defecto. Dicho esto, si tienes un problema técnico que impide usar el producto, contáctanos y lo resolvemos. Consulta los términos completos para más detalles.",

    landing_finalcta_title: "Deja de adivinar",
    landing_finalcta_subtitle: "Calcula tu probabilidad real antes de pagar el siguiente challenge.",
    landing_finalcta_button: "Empezar gratis",

    // ─── Fase 13 — Confianza del resultado (IC sobre P(PASS)) ───
    ci_label: "Confianza del resultado",
    ci_value: "IC 90%: {low} – {high}",
    ci_computing: "Calculando confianza del resultado…",
    ci_narrow: "Estimación sólida",
    ci_medium: "Estimación orientativa — con más datos se afinaría",
    ci_wide: "Dataset pequeño: toma el número central con cautela",
    ci_tooltip: "Tu P(PASS) está estimada con {n} días de datos. Re-muestreamos tus datos {b} veces y recalculamos todo el análisis con cada versión: el 90% de los resultados cae en este rango. Más datos → rango más estrecho → más fiabilidad.",

    // ─── Fase 13 — Stress test de degradación ───
    stress_title: "Stress test · margen de degradación",
    stress_desc: "Tu historial refleja tu ejecución en condiciones normales. Bajo presión se ejecuta peor. Esta matriz muestra cuánto aguanta tu EV si tu win rate cae o tus pérdidas crecen.",
    stress_run: "Ejecutar stress test",
    stress_running: "Corriendo {n} escenarios…",
    stress_rows_label: "Erosión del win rate",
    stress_cols_label: "Amplificación de pérdidas",
    stress_margin: "Margen de WR: hasta −{wr} pp · Margen de pérdidas: hasta +{loss}%",
    stress_margin_inf_wr: "Tu EV aguanta toda la erosión de WR probada (−7,5 pp)",
    stress_margin_inf_loss: "Tu EV aguanta toda la amplificación probada (+30%)",
    stress_margin_zero: "Sin margen: tu EV ya está en el límite sin degradación",
    stress_na: "N/A",
    stress_tooltip: "Erosión de WR: convertimos parte de tus días ganadores en perdedores reales de tu propio historial. Amplificación de pérdidas: cada día perdedor pierde un {pct}% más (peor ejecución de stops). EV recalculado con {sims} simulaciones por celda.",
    stress_only_bootstrap: "Disponible solo en modo con tus datos (bootstrap).",
    // ─── Sep 2026 · business simulator + audited rules ───
    biz_nav: "Negocio",
    biz_new: "nuevo",
    biz_kicker: "◆ · negocio",
    biz_title: "Simulador de negocio",
    biz_hint: "Tu estrategia operando varias cuentas a la vez con un bankroll limitado: compras evals, cobras, reinviertes y repones las cuentas quemadas. Lo que una sola cuenta no te cuenta.",
    biz_empty_title: "Primero carga tu estrategia en el paso ②. El simulador de negocio usa exactamente los mismos datos.",
    biz_empty_cta: "Ir a estrategia →",
    biz_sec_mix: "Mezcla de cuentas",
    biz_mix_desc: "Qué evaluaciones compras. Se compran por turnos mientras haya caja y hueco en el tope de cada firma.",
    biz_presets: "Ejemplos:",
    biz_preset_diversified: "Diversificada · 4 firmas",
    biz_preset_apex_only: "Solo Apex 50K",
    biz_preset_cheap_entry: "Entrada barata · 25K",
    biz_add_firm: "Firma",
    biz_add_plan: "Cuenta",
    biz_add_btn: "+ Añadir",
    biz_size: "× tamaño",
    biz_remove: "Quitar",
    biz_mix_empty: "Añade al menos una cuenta o carga un ejemplo.",
    biz_mix_full: "Máximo {n} cuentas en la mezcla.",
    biz_caps_title: "Tope de fondeadas simultáneas por firma",
    biz_col_eval: "Eval",
    biz_col_funded: "Cómo cobra",
    biz_per_month: "/mes",
    biz_plus_act: "+ {x} activ.",
    biz_rules_old: "reglas abr-26",
    biz_sec_capital: "Capital y reglas del negocio",
    biz_bankroll: "Bankroll inicial",
    biz_horizon: "Horizonte (meses)",
    biz_reinvest: "Reinversión de cada cobro",
    biz_parallel: "Todas operan a la vez desde",
    biz_slots: "Fondeadas operando por día antes",
    biz_cushion: "Colchón de caja",
    biz_daycap: "Tope de ganancia diaria por cuenta",
    biz_corr: "Correlación entre cuentas",
    biz_corr_copy: "Copy-trading",
    biz_corr_indep: "Independientes",
    biz_resets: "Usar resets de fondeada",
    biz_promos: "Aplicar promos vigentes",
    biz_vat: "Residente UE (IVA)",
    biz_nsims: "Simulaciones",
    biz_run: "Simular negocio",
    biz_running: "Simulando…",
    biz_res_title: "Resultado del negocio",
    biz_res_meta: "{n} años simulados · semilla {s} · {m} meses",
    biz_new_seed: "↻ nueva semilla",
    biz_kpi_profit: "Beneficio mediano",
    biz_kpi_profit_sub: "neto tras pagar evals, activaciones y resets · media {x}",
    biz_kpi_ruin: "Quiebra",
    biz_kpi_ruin_sub: "te quedas sin cuentas y sin caja para otra eval · ±{ci}",
    biz_kpi_p10: "Decil malo (p10)",
    biz_kpi_p10_sub: "1 de cada 10 años acaba peor que esto",
    biz_kpi_loss: "Acabar en pérdidas",
    biz_kpi_loss_sub: "menos dinero que el bankroll inicial",
    biz_kpi_first: "1er retiro",
    biz_kpi_first_sub: "día mediano · {p} de años sin ningún cobro",
    biz_kpi_payouts: "Retiros",
    biz_kpi_payouts_sub: "mediana en el horizonte",
    biz_kpi_evals: "Evals compradas",
    biz_kpi_evals_sub: "{x} en evals, activaciones y resets",
    biz_kpi_peak: "Pico de fondeadas",
    biz_kpi_peak_sub: "p90: {x} a la vez",
    biz_kpi_pocket: "A tu bolsillo",
    biz_kpi_pocket_sub: "parte no reinvertida (mediana)",
    biz_kpi_scale: "Paso a escala",
    biz_kpi_scale_sub: "día mediano · {p} de años lo alcanzan",
    biz_kpi_scale_none: "no se alcanza",
    biz_chart_fan: "Patrimonio del negocio (caja + retirado)",
    biz_chart_fan_cap: "bandas p10–p90 y p25–p75 · línea = mediana · rojo = bankroll inicial",
    biz_chart_hist: "Distribución del beneficio",
    biz_chart_hist_cap: "% de años simulados · línea = mediana",
    biz_axis_day: "día de trading",
    biz_table_title: "Qué aporta cada cuenta",
    biz_th_account: "Cuenta",
    biz_th_bought: "Evals",
    biz_th_pass: "% paso",
    biz_th_payouts: "Retiros",
    biz_th_net: "Cobrado neto",
    biz_th_breaches: "Quemadas",
    biz_th_grad: "Graduadas",
    biz_table_note: "Medias por año simulado. «Graduada» = completó los ciclos de retiro de la firma (pasa a live / Elite) y deja de simularse.",
    biz_robust_title: "¿Y si tu edge es menor?",
    biz_robust_desc: "La misma mezcla restando a cada día un 10% y un 25% de tu ganancia media diaria. Si el negocio solo funciona con el edge histórico exacto, es frágil.",
    biz_robust_base: "Edge histórico",
    biz_robust_row: "Edge −{x}%",
    biz_robust_computing: "calculando…",
    biz_th_profit: "Beneficio p50",
    biz_th_ruin: "Quiebra",
    biz_th_p10: "p10",
    biz_cash_warn: "Caja mínima mediana: {x}. El plan va al límite: si una semana no hay caja para activar una cuenta aprobada, puedes perderla. Sube el colchón o reduce la mezcla.",
    biz_load_warn: "Carga operativa: hasta {x} cuentas fondeadas a la vez. Es un trabajo diario (operar, gestionar retiros, consistencia, reactivaciones).",
    biz_warn_title: "Lo que el modelo NO ve",
    biz_warn_1: "Retrasos y revisiones de payouts, news blackouts y cambios de reglas de las firmas.",
    biz_warn_2: "Fallos de copy-trading y deslizamientos distintos entre cuentas.",
    biz_warn_3: "Regímenes de mercado que no están en tu historial: el bootstrap solo remezcla lo que ya pasó.",
    biz_warn_4: "Límites de compra (p. ej. evals por mes) y pausas por revisión de cuenta.",
    biz_opt_title: "Optimizador de mezcla",
    biz_opt_desc: "Prueba todas las combinaciones de hasta {k} cuentas de tu mezcla con la misma semilla (solo cambian las reglas), y valida las mejores con más simulaciones y con tu edge un 10% peor.",
    biz_opt_maxk: "Cuentas por mezcla (máx.)",
    biz_opt_maxruin: "Quiebra máxima aceptable",
    biz_opt_run: "Buscar la mejor mezcla · {n} combinaciones",
    biz_opt_cancel: "Cancelar",
    biz_opt_phase_screen: "probando combinaciones",
    biz_opt_phase_validate: "validando finalistas",
    biz_opt_frontier: "Frontera beneficio–quiebra",
    biz_opt_frontier_cap: "cada punto es una mezcla ({n} sims) · dorado = frontera eficiente · rojo = tu límite de quiebra",
    biz_opt_finalists: "Finalistas validadas ({n} sims)",
    biz_th_mix: "Mezcla",
    biz_th_stress: "Edge −10%",
    biz_th_first: "1er retiro",
    biz_opt_load: "Usar",
    biz_opt_bias: "Sesgo del ganador: al quedarte con la mejor de {n} mezclas, su resultado real esperado es menor que el mostrado. Elige con margen mirando la frontera y la columna «Edge −10%», no el primer puesto a ciegas.",
    biz_opt_need2: "Añade al menos 2 cuentas a la mezcla para optimizar.",
    biz_opt_locked: "El optimizador de mezcla es una función PRO.",
    biz_opt_none_ok: "Ninguna mezcla cumple tu límite de quiebra: se muestran las de menor quiebra.",
    biz_principles_title: "Principios que suelen aguantar",
    biz_principles_note: "Compruébalos con TUS datos en el simulador: todos dependen de la estrategia.",
    biz_pr_1: "Evals grandes suelen rendir más por dólar: el target escala con el tamaño, el precio no tanto, y los topes de retiro son mayores.",
    biz_pr_2: "Tamaño fijo antes que dinámico: subir el tamaño tras una racha concentra el riesgo justo cuando tienes más cuentas expuestas.",
    biz_pr_3: "No reinviertas el 100%: lo que retiras ya no se puede perder. Un 20% al bolsillo apenas frena el crecimiento y baja la quiebra.",
    biz_pr_4: "Diversifica firmas, no solo cuentas: con copy-trading todas caen el mismo día; reglas distintas no quiebran a la vez por el mismo motivo.",
    biz_pr_5: "No gastes el último dólar en evals: sin caja para activar una cuenta aprobada, puedes perderla.",
    biz_pr_6: "Empezar en 25K para «escalar después» suele salir peor: más evals, topes bajos y el mismo riesgo de ruina.",
    biz_audit_note: "Reglas auditadas en sep-2026 en las webs oficiales: Apex PA, Tradeify, Lucid, TakeProfit y Topstep 50K. Las marcadas «reglas abr-26» no se han re-auditado.",
    biz_tease: "Desbloquea el resultado completo: beneficio, quiebra, abanico de patrimonio y optimizador de mezcla.",
    biz_error: "No se pudo simular: {e}",
    audit_badge_recent: "auditada sep-26",
    audit_badge_old: "reglas abr-26",
    new_badge: "nueva",
    plan_max_micros: "máx {n} micros",
    plan_promo: "promo {code}",
    plan_vat_note: "+IVA UE",
    funded_rules_label: "fondeada",
    hint_biz_ready: "Tienes estrategia: prueba el simulador de negocio para ver varias cuentas a la vez.",
    gloss_i_title: "NEGOCIO MULTI-CUENTA",
    gloss_biz_bankroll_name: "Bankroll del negocio",
    gloss_biz_bankroll_body: "El dinero con el que arrancas para comprar evaluaciones, activaciones y resets. No se opera con él: lo que se arriesga en mercado es el capital de la firma. Si se agota y no queda ninguna cuenta viva, el negocio quiebra.",
    gloss_biz_ruin_name: "Quiebra del negocio",
    gloss_biz_ruin_body: "Porcentaje de años simulados en los que te quedas sin cuentas vivas y sin caja para comprar otra eval. Es distinto de perder una cuenta: un negocio sano pierde cuentas constantemente y las repone con lo que cobra.",
    gloss_biz_reinvest_name: "Reinversión",
    gloss_biz_reinvest_body: "Qué parte de cada retiro vuelve a la caja para comprar evals nuevas. Lo que no se reinvierte va a tu bolsillo y ya no se puede perder; por eso reinvertir menos del 100% reduce la quiebra.",
    gloss_biz_copy_name: "Copy-trading y correlación",
    gloss_biz_copy_body: "Replicar la misma ejecución en todas las cuentas. Multiplica los cobros, pero también hace que todas pierdan el mismo día: con 20 cuentas copiadas, un mal día no quema una cuenta, quema veinte. El simulador lo modela por defecto.",
    gloss_biz_caps_name: "Tope de cuentas por firma",
    gloss_biz_caps_body: "Máximo de cuentas fondeadas simultáneas que permite cada firma, sumando todos sus productos (p. ej. Apex 20, Tradeify 5 entre Flex y Daily). Limita cuánto puede crecer un negocio apoyado en una sola firma.",
    gloss_biz_graduation_name: "Graduación (ciclos de retiro)",
    gloss_biz_graduation_body: "Algunas firmas limitan los retiros de la cuenta fondeada simulada: Apex 6 ciclos, Tradeify Flex 5, Lucid 4. Después la cuenta pasa a live / Elite con otras reglas. El simulador la retira del negocio y libera su hueco.",
    gloss_biz_bias_name: "Sesgo del ganador",
    gloss_biz_bias_body: "Si pruebas muchas combinaciones y te quedas con la mejor, parte de su ventaja es suerte de la muestra. Su resultado real esperado es menor que el mostrado. Por eso el optimizador valida a los finalistas con más simulaciones y con el edge un 10% peor.",
  },
  en: {
    // Fase 19 · referrals
    promo_ref_lead: "Referral discount",
    promo_ref_detail: "via {code} · on all plans",
    // Fase 19 · summer sale
    promo_banner_lead: "Summer sale",
    promo_banner_detail: "on all plans · until Aug 31",
    promo_badge: "summer −{pct}%",
    promo_save: "save {amt}",
    promo_first_month: "first month",
    promo_first_year: "first year",
    // Fase 18 · "simulating" screen
    sim_kicker: "04 · simulating",
    sim_kicker_compact: "simulating",
    sim_title: "Running Monte Carlo analysis",
    sim_subtitle: "block bootstrap · common random numbers",
    sim_target: "target",
    sim_limit: "limit",
    sim_start_capital: "starting capital",
    sim_distribution: "distribution",
    sim_starting: "starting engine",
    sim_complete: "analysis complete",
    sim_stage_1: "generating price paths",
    sim_stage_2: "block resampling · block bootstrap",
    sim_stage_3: "detecting autocorrelation",
    sim_stage_4: "applying common random numbers (CRN)",
    sim_stage_5: "confidence intervals · double bootstrap",
    sim_stage_6: "running 4×4 stress grid",
    sim_stage_7: "estimating Kelly fraction",
    sim_stage_8: "consolidating verdict",
    app_title: "PROP · FORGE",
    app_subtitle: "monte carlo for prop firm challenges",
    app_tagline: "› monte carlo for prop firm challenges",
    live_badge: "LIVE · CLIENT-SIDE",
    meta_counter: "{firms} firms · {plans} plans",

    // Tabs (Phase 15-16 · Block 1: 5 tabs with semantic keys)
    tab_firms: "FIRMS",
    tab_strategy: "STRATEGY",
    tab_lab: "LAB",
    tab_results: "RESULTS",
    tab_help: "HELP",
    tab_account: "ACCOUNT",
    // Phase 17B · Block 1 — Step navigation (steps ARE the navigation)
    stepnav_1: "Pick a firm",
    stepnav_2: "Load your strategy",
    stepnav_3: "Review your Lab",
    stepnav_4: "Simulate & decide",
    // Phase 17B · Block 2 — GuideDrawer
    guide_open_full: "📖 open the full guide · 10 min",
    guide_open_page: "open as a page →",
    guide_drawer_kicker: "Guide · 10 min",
    guide_drawer_title: "How to use Prop Forge",
    guide_drawer_aria: "Full Prop Forge guide",
    guide_drawer_close: "close guide",
    // Phase 17B · Block 3 — Account v2
    account_open_aria: "Open account",
    account_back: "← back",
    account_plans_title: "Plans",
    account_current_badge: "your current plan",
    account_switch_annual: "Switch to Annual →",
    account_pro_cta: "Upgrade to Pro →",
    account_annual_cta: "Upgrade to Annual →",
    account_downgrade_hint: "To cancel or downgrade, use Manage subscription.",
    account_logout: "Sign out",
    account_section_yours: "Your account",
    account_section_manage: "Manage subscription",
    account_section_manage_hint: "card, invoices, cancel — Stripe secure portal",
    account_plan_free_price: "Free",
    account_plan_pro_price: "€31/month",
    account_plan_annual_price: "€199/year",
    account_plan_free_features: '["Monte Carlo simulation","21 real firms","Simple mode (Gaussian)","No exports","No Stress test"]',
    account_plan_pro_features: '["Everything in Free","Bootstrap from real data","Stress test 4×4","Compare up to 4 accounts","PNG + JSON exports"]',
    account_plan_annual_features: '["Everything in Pro","2 months free","Advanced sizing sweep","Funded mode","Priority support"]',
    tab_firms_title: "select a firm",
    tab_firms_hint: "pick the firm and account size · or configure parameters manually",
    tab_firms_epigraph: "22 real firms · 81 accounts · rules audited Sep 2026",
    tab_strategy_title: "your strategy",
    tab_strategy_hint: "enter your backtest data. if you have a P&L history, use data mode — it's the most reliable",
    tab_lab_title: "your strategy under examination",
    tab_lab_hint: "honest analysis, no firm involved",
    tab_results_title: "results",
    tab_results_hint: "probabilities computed from your strategy",
    tab_results_empty: "run a simulation first · tab 02",
    tab_help_title: "help & glossary",
    tab_help_hint: "every term explained, sorted by section",

    // Phase 17 · Block 5 — Account view
    account_title: "your account",
    account_hint: "your plan, your subscription, managed here",
    account_loading: "loading subscription…",
    account_error: "we couldn't load your subscription.",
    account_retry: "retry",
    account_plan_label: "Plan",
    account_status_label: "Status",
    account_renewal_label: "Renewal",
    account_plan_free: "Free",
    account_plan_pro: "Pro",
    account_plan_annual: "Annual",
    account_status_active: "Active",
    account_status_canceled: "Canceled",
    account_status_past_due: "Past due",
    account_status_incomplete: "Incomplete",
    account_status_trialing: "Trialing",
    account_status_unpaid: "Unpaid",
    account_renews_on: "Renews on {date}",
    account_cancels_on: "Ends on {date}",
    account_manage_btn: "Manage subscription",
    account_portal_loading: "opening portal…",
    account_upgrade_btn: "Upgrade to Pro",
    account_no_sub_body: "You're on the free plan. Upgrade to Pro or Annual from the STRATEGY tab to unlock all firms, exports, comparator, and funded mode.",
    // Aliases
    tab_01: "FIRMS",
    tab_02: "STRATEGY",
    tab_03: "RESULTS",
    tab_04: "HELP",
    tab_01_title: "select a firm",
    tab_01_hint: "pick the firm and account size · or configure parameters manually",
    tab_01_epigraph: "22 real firms · 81 accounts · rules audited Sep 2026",
    tab_02_title: "your strategy",
    tab_02_hint: "enter your backtest data. if you have a P&L history, use data mode — it's the most reliable",
    tab_03_title: "results",
    tab_03_hint: "probabilities computed from your strategy",
    tab_03_empty: "run a simulation first · tab 02",
    tab_04_title: "help & glossary",
    tab_04_hint: "every term explained, sorted by section",

    // Phase 15-16 · Block 1 — LabTab
    lab_tab_purpose: "Your strategy in the abstract — no firm involved. If there are red flags here, no firm fixes them.",
    lab_empty_title: "The Lab analyzes your real track record. Load your data in STRATEGY to get started.",
    lab_empty_cta: "→ go to STRATEGY",

    // Phase 15-16 · Block 2 — ProgressStepper
    step_nav_1: "Pick a firm",
    step_nav_2: "Load your strategy",
    step_nav_3: "Review your Lab",
    step_nav_4: "Simulate",
    step_nav_5: "Decide",
    tabs_guide_button: "guide",

    // Phase 15-16 · Block 3 — TabCoach
    coach__show: "show guide",
    coach__dismiss: "dismiss",
    coach__chamber__purpose: "Here you choose which rules you'll be playing against.",
    coach__chamber__steps: '["Click a firm, then a plan (size).", "Read the summary: target, drawdown, daily loss and fee.", "Torn between firms? The Lab will tell you which ones are compatible with you."]',
    coach__chamber__cta: "Next: load your strategy →",
    coach__strategy__purpose: "Here you give the simulator the way you trade.",
    coach__strategy__steps: '["Paste your daily P&L or upload the CSV (European 1.234,56 format works too).", "Check the \\"first parsed values\\" and any warnings.", "No data at hand? Hit \\"◇ load example\\" and try everything in 60 seconds."]',
    coach__strategy__cta: "Next: review your Lab →",
    coach__lab__purpose: "Your strategy under examination, before any firm enters the picture.",
    coach__lab__steps: '["Check the edge verdict: real, or indistinguishable from luck?", "Note your expected worst streak — knowing it prevents quitting the system at the worst moment.", "Below: the firms compatible with the drawdown you generate."]',
    coach__lab__cta: "Next: simulate against your firm →",
    coach__oracle__purpose: "Here's your answer. Read it in this order.",
    coach__oracle__steps: '["The verdict on top translates it; P·PASS and its confidence (CI) are the base.", "BANKROLL · 95%: what attempting this seriously really costs.", "If you enabled funded: the typical outcome is the MEDIAN, not the mean."]',
    coach__oracle__cta: "Last step: the decision checklist ↓",
    coach__business__purpose: "See your strategy as a business: many accounts, a limited bankroll and a whole year.",
    coach__business__steps: '["Pick the account mix (or load an example) and set each account size.", "Set bankroll, reinvestment and when all accounts start trading at once.", "Simulate, check ruin and the bad decile, then try the mix optimizer."]',
    coach__business__cta: "Simulate business ↓",

    // Phase 15-16 · Block 4 — Toast hints
    hint_go: "go",
    hint_plan_selected: "✓ {firm} {plan} selected · next: load your strategy (02)",
    hint_data_loaded: "✓ {n} days loaded · next: review your Lab (03)",
    hint_sim_done: "✓ Simulation ready · don't miss the decision checklist at the end",
    hint_stress_margin: "stress complete · you've got cushion to be human",

    // Phase 15-16 · Block 5 — VerdictCard (traffic-light)
    verdict_green_headline: "Trading the way you do, you'd pass 1 in {oneInN} attempts — and buying this challenge is profitable long-term ({ev} expected per attempt).",
    verdict_green_line2: "Realistic plan: budget {attemptsMedian} attempts ({bankroll95} to be near-certain).",
    verdict_green_line3: "Typical time to pass: {medianDays} trading days.",
    verdict_amber_headline: "You'd pass 1 in {oneInN} attempts and the math is profitable, but barely — a bad stretch of variance or slightly worse execution can eat it.",
    verdict_amber_line2: "Realistic plan: budget {attemptsMedian} attempts ({bankroll95} to be near-certain).",
    verdict_amber_line3: "Typical time to pass: {medianDays} trading days.",
    verdict_amber_extra: "Check the stress test and sizing before deciding.",
    verdict_red_headline: "With this setup you lose money long-term: each attempt costs you {ev} on average.",
    verdict_red_line2: "Before paying anything: try a smaller size (sizing), another firm (compatibles in your Lab), or review your strategy's flags.",
    verdict_no_funded: "(EV computed without the funded cycle — enable it for the full number)",
    verdict_footnote: "The full numbers are below — this is just the translation.",
    funded_verdict_negative: "Most likely the account dies before you withdraw — but {pp}% of the time you land at least one payout, and that's what carries the math.",
    funded_verdict_positive: "The typical case already withdraws: median {medianNet} with {pp}% chance of at least one payout.",

    // Phase 15-16 · Block 6 — Decision Checklist
    dc_title: "✓ GO OR NO-GO?",
    dc_item_1: "Strategy Lab clean",
    dc_item_2: "Positive EV (long-term, it's a business)",
    dc_item_3: "Decent result confidence",
    dc_item_4: "Affordable bankroll",
    dc_item_5: "Margin in the stress test",
    dc_item_6: "Realistic timing",
    dc_sub_lab_ok: "lab analyzed · review the flags in the LAB tab",
    dc_sub_lab_missing: "review your Lab (03)",
    dc_sub_ev_bad: "EV of {ev} — you lose money on average per attempt",
    dc_sub_ci_wide: "CI wide · more data would sharpen it",
    dc_sub_ci_none: "load more data to know the result confidence",
    dc_sub_bankroll: "compare {br95} with your real budget",
    dc_sub_stress_run: "run the stress test ↑",
    dc_sub_stress_unlock: "unlock it with Pro",
    dc_sub_stress_tight: "one of the margins is 0 — it's tight",
    dc_sub_time: "median {d}d · P90 {p90}d: does it work for you?",
    dc_footer: "All ✓ → go, and you know what game you're playing. Any ✗ → the tool just saved you the cost of finding out by paying.",

    // Phase 15-16 · Block 7 — Paywall tease
    tease_ready: "Computed from your data ✓",
    tease_cta: "Unlock with Pro →",
    tease_funded_line: "Your full-cycle EV and your probability of landing at least one payout are ready.",
    tease_stress_line: "Your degradation margin is computed: how much worse you can get before losing money.",
    tease_sizing_line: "Your optimal size for this firm is computed.",
    funded_teaser_title: "Funded cycle result",
    funded_teaser_computing: "Computing what happens after you pass…",

    // Phase 15-16 · Block 8a — trade-level parser
    boot_trade_level: "{nTrades} trades → {nDays} trading days",

    // Phase 15-16 · Block 8c — Simple presets
    preset_label: "profiles",
    preset_tooltip: "Realistic profiles to explore without your own data. Tweak anything afterwards.",
    preset_1: "Conservative scalper",
    preset_2: "Aggressive scalper",
    preset_3: "Swing 1:2",
    preset_4: "Balanced intraday",

    // Phase 15-16 · Block 9 — Demo mode
    landing_demo_cta: "View demo (no signup)",
    demo_banner: "You're viewing the simulator with example data. To use your own history:",
    demo_banner_cta: "→ sign up free",

    // Phase 16B · Block 1 — Export guides
    exp__title: "How do I export my data?",
    exp__tradovate__name: "Tradovate",
    exp__tradovate__steps: '["Open your dashboard → Performance tab.", "Pick the date range and hit the download icon (CSV).", "Upload that file here as-is — we detect the columns and group by day."]',
    exp__ninjatrader__name: "NinjaTrader 8",
    exp__ninjatrader__steps: '["Control Center → Trade Performance.", "Generate the period report and right-click → Export → CSV.", "Upload as-is: one row per trade is exactly what we expect."]',
    exp__metatrader__name: "MetaTrader 4/5",
    exp__metatrader__steps: '["History tab → right-click → Report (HTML or CSV).", "If HTML, open it in Excel and save as CSV.", "Upload the CSV — we read \\"Close Time\\" and \\"Profit\\" and group by day."]',
    exp__tradingview__name: "TradingView",
    exp__tradingview__steps: '["Paper Trading panel or connected broker → History.", "Export the history to CSV.", "Upload as-is."]',
    exp__other__name: "Other / by hand",
    exp__other__steps: '["Any CSV with a P&L column (and optionally date) works.", "Or just paste a list: one result per line.", "European format (1.234,56) also works."]',

    // Phase 16B · Block 4 — Password recovery
    auth_forgot_link: "forgot your password?",
    auth_back_signin: "← back to sign in",
    auth_submit_forgot: "send recovery link",
    auth_reset_sent: "We've sent you a link. Check your inbox (and spam just in case).",
    reset_kicker: "PASSWORD RESET",
    reset_title: "Set your new password",
    reset_new: "new password",
    reset_confirm: "confirm",
    reset_submit: "save and sign in",
    reset_too_short: "Minimum 6 characters.",
    reset_mismatch: "Passwords don't match.",
    reset_done: "✓ Password updated. Redirecting to the simulator…",

    // Phase 16B · Block 5 — Invite link
    invite_label: "invite",
    invite_copied: "✓ copied",
    invite_tooltip: "Share Prop Forge with another trader",
    invite_share_text: "Prop Forge — calculate your real probability of passing a challenge before paying for it.",
    help_restart_guide: "restart full guide",

    btn_next_strategy: "next: your strategy →",
    strategy_empty: "first select a firm in the firms tab",

    // Hero (legacy)
    hero_tagline: "monte carlo for prop firm challenges",
    hero_quote: "",
    hero_quote_cite: "",
    hero_quote_author: "",
    hero_firms: "firms",
    hero_plans: "plans",

    step_1_title: "PICK A FIRM",
    step_1_subtitle: "choose a firm",
    step_1_hint: "each firm has its own rules. pick yours.",
    step_2_title: "select an account",
    step_2_subtitle: "choose an account",
    step_2_hint: "pick the account size you want to evaluate",
    step_3_title: "YOUR STRATEGY",
    step_3_subtitle: "your stats",
    step_3_hint: "your backtest statistics",

    step_custom_title: "build your own config",
    step_custom_subtitle: "custom config",
    step_custom_hint: "custom mode active · edit each parameter",
    step_custom_body:
      "you are defining your own config from scratch · defaults match a typical $50k futures account (6% target, 5% trailing EOD drawdown).\n\nall fields are unlocked in the account panel on the left.",

    filter_all: "ALL",
    filter_futures: "FUTURES",
    filter_forex: "FOREX",
    filter_custom: "CUSTOM",

    custom_card_title: "BUILD YOUR OWN CONFIG",
    custom_card_desc:
      "when no existing firm reflects your reality — define every rule from scratch.",
    custom_card_cta: "open",

    welcome_title: "How it works",
    welcome_hide: "hide",
    welcome_show: "guide",
    welcome_lead:
      "Prop Forge calculates your real probability of passing any prop firm challenge. It does this by simulating 10,000 day-by-day attempts using your own trading data.",
    welcome_flow_title: "3 steps",
    welcome_flow_1: "Pick the firm and account you want to evaluate",
    welcome_flow_2: "Enter your trading data (P&L or stats)",
    welcome_flow_3: "Get your probability and expected value per attempt",
    welcome_flow_4: "",
    welcome_needs_title: "What you need",
    welcome_needs_1: "A daily P&L history (csv or list of numbers) — recommended",
    welcome_needs_2: "Or your backtest stats: win rate, average win/loss",
    welcome_needs_3: "",
    welcome_needs_4: "",
    welcome_footer:
      "Never done a backtest? Try the 'load example' button to see how it works.",

    section_pnl: "A · DAILY P&L",
    section_mae: "B · ADVERSE EXCURSION",
    section_mae_opt: "(optional)",
    section_account: "C · ACCOUNT",
    section_sim: "D · SIMULATION",

    calibrate_cta: "† calibrate from CSV",

    field_wr: "win rate",
    field_mu_win: "μ win",
    field_sigma_win: "σ win",
    field_mu_loss: "μ loss",
    field_sigma_loss: "σ loss",
    field_tail_prob: "p(spike)",
    field_tail_mult: "spike mult",
    field_mae_win: "mae win",
    field_mae_loss: "mae loss",
    field_n_sims: "paths",

    field_capital: "capital",
    field_target: "target",
    field_dd_type: "dd type",
    field_dd_value: "dd $",
    field_floor_lock: "floor lock",
    field_daily_loss: "daily loss",
    field_dll_value: "dll $",
    field_dll_fatal: "dll fatal",
    field_consistency: "consistency",
    field_consistency_pct: "% (0-1)",
    field_consistency_type: "type",
    field_min_days: "min days",
    field_max_days: "max days",
    field_phases: "phases",
    field_fee: "fee",
    field_fee_type: "fee type",
    field_activation_fee: "activation",
    field_profit_split: "profit split",
    field_max: "max",

    dd_type_trailing_eod: "Trailing EOD",
    dd_type_trailing_intraday: "Trailing Intraday",
    dd_type_static: "Static",

    floor_lock_none: "None",
    floor_lock_at_capital: "At capital",
    floor_lock_at_target: "At target",
    floor_lock_at_cap_plus_100: "Cap + $100",

    cons_vs_total: "vs total",
    cons_vs_target: "vs target",

    phases_1: "1 phase",
    phases_2: "2 phases",
    fee_one_time: "one time",
    fee_monthly: "monthly",

    btn_run: "run simulation",
    btn_running: "simulating",
    btn_edit: "edit",
    btn_close: "close",
    btn_reset_preset: "↺ reset to preset",
    btn_add_compare: "＋ add to compare  ({n}/4)",
    btn_compare_full: "‹ compare full (4/4) ›",
    btn_compare_clear: "↺ clear",
    btn_run_all: "✦  RUN ALL · {n}  ✦",
    btn_run_all_disabled: "‹ need at least 2 firms ›",
    btn_export_png: "↓ export · PNG",
    btn_export_json: "↓ export · JSON",
    btn_csv_upload: "† upload .csv",
    btn_csv_sample: "◇ load sample",
    btn_csv_clear: "↺ clear",
    btn_csv_apply: "✦  APPLY  ✦",
    btn_csv_close: "✕ close",

    modified_badge: "◆ ALTERED",
    popular_badge: "★ POPULAR",
    monthly_badge: "MONTHLY",
    overnight_badge: "◇ OVERNIGHT",
    two_phase_badge: "╳ 2·PHASE",

    // results chapters
    reveal_tag: "results",
    reveal_title: "RESULTS",
    chart_chapter: "paths",
    chart_chapter_title: "EQUITY PATHS",
    ledger_chapter: "ledger",
    ledger_chapter_title: "RESULTS TABLE",

    kpi_p_pass: "P · PASS",
    kpi_p_pass_sub: "break-even {x}% · below, not profitable",
    kpi_p_pass_help: "Probability of passing the challenge with your strategy. Compared to break-even, it tells you if the firm is profitable long-term.",
    kpi_ev: "EV · EVAL (SINGLE PAYOUT)",
    kpi_ev_sub: "avg cost: {x}",
    kpi_ev_help: "Expected net value per attempt. Positive = profitable; negative = losing money long-term.",
    kpi_p_dd: "P · DRAWDOWN",
    kpi_p_dd_sub: "fail by drawdown",
    kpi_p_dd_help: "Probability of failing because the drawdown limit is breached.",
    kpi_p_timeout: "P · TIMEOUT",
    kpi_p_timeout_sub: "the account expires without passing",
    kpi_p_timeout_help: "Probability of running out of max days before reaching the target.",
    kpi_p_dll: "P · DLL",
    kpi_p_dll_sub: "fail by daily-loss breach",
    kpi_p_dll_help: "Probability of failing by breaching a fatal daily loss limit.",
    kpi_p_fail: "P · FAIL",
    kpi_p_fail_sub: "aggregated failure probability",
    kpi_p_fail_help: "Aggregated probability of any failure path.",
    kpi_mean_days: "DAYS · PASS",
    kpi_mean_days_sub_ok: "median {x}d",
    kpi_mean_days_sub_none: "no PASS samples",
    kpi_mean_days_help: "Trading days needed when you do pass.",
    kpi_p90_days: "P90 DAYS",
    kpi_p90_days_sub: "90% pass before",
    kpi_p90_days_help: "90% of PASS outcomes occur in fewer days than this percentile.",
    kpi_bankroll: "BANKROLL · 95%",
    kpi_bankroll_sub_ok: "{x} attempts",
    kpi_bankroll_sub_zero: "P(PASS) ≈ 0",
    kpi_bankroll_help: "Capital needed for a 95% probability of passing at least once.",
    kpi_median_attempts: "MEDIAN ATTEMPTS",
    kpi_median_attempts_sub: "to first PASS",
    kpi_median_attempts_help: "Number of attempts to first PASS (geometric median).",

    chart_result_dist: "‡ OUTCOME DISTRIBUTION",
    chart_days_pass: "‡ DAYS TO PASS",
    chart_days_fail: "‡ DAYS TO FAIL",
    chart_cap_pass: "median {m}d · p90 {p90}d · clipped at p95",
    chart_cap_fail: "median {m}d · clipped at p95",
    chart_no_samples: "no samples",
    chart_empty: "◇ no samples",

    stat_p_pass: "probability of passing",
    stat_ev_net: "expected net value",
    stat_br99: "bankroll at 99%",
    stat_att99: "attempts at 99%",
    stat_roi: "ROI per PASS",
    stat_split: "profit split",
    stat_footer:
      "› sims: {sims} · pass: {pass} · dd: {dd} · timeout: {to} · dll: {dll} · payout/pass: ",

    selected_plan_label: "› SELECTED PLAN",
    summary_capital: "CAPITAL",
    summary_target: "TARGET",
    summary_dd: "DD",
    summary_fee: "FEE",
    summary_split: "SPLIT",

    account_summary_title: "THE CHAMBER — IN PLAIN LANGUAGE",
    account_summary_intro: "effective rules the oracle will honour",
    summary_objective: "objective · make {tgt} on {cap} ({pct}%)",
    summary_dd_static: "drawdown · static {dd} · fixed floor at {floor}",
    summary_dd_trailing_eod: "drawdown · trailing EOD of {dd}",
    summary_dd_trailing_intraday: "drawdown · intraday trailing {dd} · moves with every equity peak",
    summary_floor_none: "floor never anchors · keeps rising with equity",
    summary_floor_at_cap: "floor anchors at starting capital ({cap})",
    summary_floor_at_target: "floor anchors at capital + target ({level})",
    summary_floor_cap100: "floor permanently locks at capital + $100 once you pass capital + DD + $100",
    summary_dll_fatal: "daily loss · {v} · FATAL (breach = instant fail)",
    summary_dll_soft: "daily loss · {v} · non-fatal (pauses the day, account survives)",
    summary_dll_none: "no daily loss limit",
    summary_cons_target: "consistency · {pct}% vs TARGET · if a single day exceeds that fraction of original target, effective target rises",
    summary_cons_total: "consistency · {pct}% vs TOTAL · PASS is blocked while best-day > {pct}% of cumulative profit",
    summary_cons_none: "no consistency rule",
    summary_days_both: "minimum {min} days · maximum {max} days",
    summary_days_min_only: "minimum {min} days · no max cap",
    summary_days_max_only: "no minimum · maximum {max} days",
    summary_days_none: "no day limits",
    summary_fee_onetime: "tribute · {f} one-time",
    summary_fee_onetime_act: "tribute · {f} one-time + {a} activation on pass",
    summary_fee_monthly: "tribute · {f}/mo (scales with attempt duration)",
    summary_fee_monthly_act: "tribute · {f}/mo + {a} activation on pass",
    summary_split: "split · {pct}% of profits",
    summary_phase2: "phase 2 · target {tgt} · equity resets at start · min {min}d, max {max}",
    summary_phase2_nomax: "phase 2 · target {tgt} · equity resets at start · min {min}d, no cap",

    warn_monthly_fee: "monthly fee · every month you delay passing costs you another {fee}",
    warn_apex: "apex account · 30 calendar days · no reset · out-of-time counts as TIMEOUT",
    warn_topstep: "topstep does not impose a DLL · it's trader-configurable in TopstepX · enable it via 'edit' to model a personal cap",
    warn_cons_vs_target: "consistency {pct}% vs TARGET · if a single day exceeds that fraction of original target, effective target rises · does not block, hardens",
    warn_cons_vs_total: "consistency {pct}% vs TOTAL · PASS is blocked while best-day > {pct}% of cumulative profit · unlocks by trading more days",
    warn_two_phase: "two phases · not one · cross the first (target {t1}) to face the second (target {t2}) · equity resets between phases",
    warn_modified: "you have modified the preset values · simulation uses your values, not the originals",

    empty_configure: "configure your strategy and press ",
    empty_render_here: "no results yet · run a simulation to see the data",
    loading_msg: "simulating {n} paths",

    compare_rack_title: "COMPARE",
    compare_rack_slots: "{n}/4 firms",
    compare_slot: "SLOT·{n}",
    compare_help: "ranking below · winners marked in gold",
    compare_results_title: "‡ COMPARISON · RANKED BY EV",
    compare_results_sub: "same strategy across all · the one yielding most EV prevails",
    compare_col_rank: "RANK · PLAN",
    compare_col_ppass: "P · PASS",
    compare_col_ev: "EV / ATTEMPT",
    compare_col_cost: "AVG COST",
    compare_col_mean: "MEAN DAYS",
    compare_col_p90: "P90 DAYS",
    compare_col_br95: "BANKROLL 95%",
    compare_col_roi: "ROI / PASS",
    compare_winner_prefix: "★ WINNER ·",
    compare_winner_ev: "· highest EV at ",
    compare_winner_ppass: "· p(pass) ",
    compare_forging: "simulating {n} paths",

    csv_title: "↓ CALIBRATE FROM CSV",
    csv_help_1: "› paste a CSV with one P&L value per day (positive = win, negative = loss, 0 = skip)",
    csv_help_2: "› or drop a file · a sample is available for testing",
    csv_col_label: "pnl column",
    csv_skip_header: "skip header",
    csv_detected_title: "§ DETECTED",
    csv_calibrated_title: "§ CALIBRATED",
    csv_samples: "samples",
    csv_wins: "wins",
    csv_losses: "losses",
    csv_total: "total pnl",
    csv_avg_day: "avg day",
    csv_err_samples: "need at least 5 non-zero P&L samples.",
    csv_err_no_wins: "no winning days found.",
    csv_err_no_losses: "no losing days found.",
    csv_placeholder: "day,pnl\n1,438\n2,-194\n3,620\n...",
    csv_col_option: "{header} · {n} nums{neg}",
    csv_col_neg: " · has neg",

    footer_l1: "educational simulation · data verified april 2026",
    footer_l2: "rules can change without notice · always verify official sources before purchasing",
    footer_l3: "this is not financial advice",

    size_prefix: "",
    configure_word: "› configure",

    // Results section titles
    ledger_chapter_title_timing: "TIMING",

    // Glossary
    gloss_search_placeholder: "search term",
    gloss_a_title: "SIMULATION METHODS",
    gloss_b_title: "DRAWDOWN TYPES",
    gloss_c_title: "FLOOR LOCK",
    gloss_d_title: "CONSISTENCY RULES",
    gloss_e_title: "MAE",
    gloss_f_title: "METRICS OUTPUT",
    gloss_simple_name: "SIMPLE MODE · gaussian",
    gloss_simple_body:
      "generates daily P&Ls with separate normal distributions for winning and losing days. fast, simple. assumes your returns follow a Gauss curve — which is NOT true in real trading. underestimates fat tails (outliers).\n\n→ use it when you only have means and standard deviations from your backtest\n→ avoid it if your strategy has extreme days (NFP, FOMC, catalysts)",
    gloss_bootstrap_name: "BOOTSTRAP MODE · empirical",
    gloss_bootstrap_body:
      "instead of assuming a distribution, it samples randomly from a list of daily P&Ls you paste directly from your backtest. preserves the real skewness and tails of your strategy. far more mathematically honest.\n\n→ use it when you have at least 100 days of real backtest\n→ requires pasting the data (txt, csv, one column with numbers)",
    gloss_static_name: "STATIC DRAWDOWN",
    gloss_static_body:
      "the max-loss floor is fixed at capital − ddValue. never moves. the most permissive. used by FTMO, FundedNext CFD, FundingPips, The5%ers.\n\nexample: 100K with 10% DD → floor at 90K, always.",
    gloss_teod_name: "TRAILING EOD",
    gloss_teod_body:
      "floor rises based only on end-of-day balance. intraday you can take dips without failing. far more realistic for human trading. used by Topstep, Tradeify, MFFU.\n\nexample: you close the day at 52K (capital 50K, DD 2K) → floor rises to 50K. next day you start with 50K of cushion.",
    gloss_tintraday_name: "TRAILING INTRADAY",
    gloss_tintraday_body:
      "floor rises tick-by-tick with equity peaks, including unrealized gains. the strictest — punishes you for holding unrealized profit and not closing it. used by Apex Intraday, MFFU Rapid, TPT PRO.\n\nexample: by mid-morning you're +3K unrealized → floor already rose 3K. if you give that profit back, floor stays up.",
    gloss_fl_none_name: "NONE",
    gloss_fl_none_body:
      "the floor never anchors, keeps rising forever. topstep eval works this way: your DD trail never relaxes.",
    gloss_fl_cap_name: "AT_CAPITAL",
    gloss_fl_cap_body:
      "the floor stops rising when it reaches starting capital. from there on it cannot go below the starting point. used in TPT, TradeDay, Leeloo, Earn2Trade.",
    gloss_fl_target_name: "AT_TARGET_LEVEL",
    gloss_fl_target_body:
      "the floor anchors at capital + target (e.g. 53K for a 50K with 3K target). apex does this: once you pass eval, they cannot touch you below the target.",
    gloss_fl_cap100_name: "AT_CAPITAL_PLUS_100",
    gloss_fl_cap100_body:
      "the floor locks at capital + $100 once EOD balance exceeds capital + ddValue + 100. tradeify, fundednext, mffu, phidias. the \"courtesy margin\" model.",
    gloss_cons_target_name: "VS_TARGET · topstep-style",
    gloss_cons_target_body:
      "if a single day earns more than X% of the original target, the EFFECTIVE target rises to (bestDay / X%). does not block PASS, hardens it.\n\nexample topstep 50K (target 3K, consistency 50%): one day you hit +2K → new effective target is 4K (2K / 0.5).",
    gloss_cons_total_name: "VS_TOTAL · fundednext-style",
    gloss_cons_total_body:
      "PASS is blocked while your best day exceeds X% of cumulative profit. to unblock it, keep trading until that day's weight dilutes.\n\nexample MFFU 50K (consistency 40%): best day 2K, cumulative 3K → ratio 67% → blocked. keep earning until best-day ≤ 40% of total.",
    gloss_mae_name: "MAE · maximum adverse excursion",
    gloss_mae_body:
      "MAE is the maximum unrealized loss during a day before closing. closed +500 but at mid-morning you were -300 on your open position → MAE was 300.\n\non trailing intraday DD, MAE does kill the account — even if you close positive, if at any point during the day you touched the floor, you failed.\n\nsimple mode generates MAE via a gamma distribution (unreliable). bootstrap mode can read MAE directly if you include it in your data (MAE column in the CSV).",
    gloss_ppass_name: "P(PASS)",
    gloss_ppass_body: "probability that an attempt ends up passing the challenge.",
    gloss_ev_name: "EV · expected value",
    gloss_ev_body: "expected value per attempt: P(PASS) × payout − avg_cost. if EV < 0 you lose money in the long run.",
    gloss_breakeven_name: "BREAK-EVEN P(PASS)",
    gloss_breakeven_body: "minimum probability of passing for EV to be positive. your actual P(PASS) must exceed this threshold.",
    gloss_bankroll_name: "BANKROLL 95% / 99%",
    gloss_bankroll_body: "total money required to have 95% (or 99%) probability of passing at least once. assumes independent attempts.",
    gloss_days_name: "DAYS TO PASS",
    gloss_days_body: "distribution of days taken to pass, when you pass. mean, median, p90.",
    gloss_attempts_name: "ATTEMPT DISTRIBUTION",
    gloss_attempts_body: "how many attempts until the first PASS. geometric median.",

    // Strategy v2 — mode toggle
    mode_title: "MODE",
    mode_simple: "SIMPLE · gaussian",
    mode_simple_sub: "normal distributions over means and std devs. fast. assumes gaussian tails (not true).",
    mode_bootstrap: "DATA · empirical (bootstrap)",
    mode_bootstrap_sub: "random sampling from your real P&Ls. preserves skewness and tails. most reliable if you have ≥ 100 days.",
    mode_recommended: "RECOMMENDED",

    section_pnl_v2: "TRADING DATA",
    section_mae_v2: "INTRADAY RISK · MAE",
    section_costs: "COSTS & COMMISSIONS",
    section_behavioral: "BEHAVIORAL MODEL",

    // Section descriptions (italic gray, shown under each collapsible title)
    section_pnl_desc: "Your backtest data · win rate, P&L on winning and losing days · the base of every calculation",
    simple_info_title: "When to use this mode?",
    simple_info_body: "If you haven't done real trading yet and don't have a daily P&L history. For example, if you're testing an idea on paper and only have theoretical numbers: 'I think my win rate would be 40% and my winners would be twice my losers.'\n\nThis mode generates simulated days from those numbers, assuming they follow a normal distribution. It's a quick approximation but less reliable than Data mode, which uses your literal numbers without making things up.\n\nIf you have at least 30 days of real trading, use Data mode. It's more honest.",
    section_mae_desc: "Max intraday loss before close · critical for trailing-intraday drawdowns",
    section_costs_desc: "Commissions that erode net P&L · skip it if your data is already net",
    section_behavioral_desc: "What counts as a valid day and how max-days are counted",
    section_postpass_desc: "What happens after you pass · payout cycles and post-funded consistency",

    // Section badges
    section_badge_advanced: "ADVANCED · OPTIONAL",
    section_badge_pro: "PRO · OPTIONAL",

    // Quick Start panel (above Trading Data)
    quick_start_title: "QUICK START",
    quick_start_body: "for a quick estimate just fill the TRADING DATA section. everything below is optional advanced tuning — leave it as-is if you're not sure.",

    bootstrap_help: "Paste your backtest daily P&Ls · one number per line, or CSV with columns. You can also upload a .xlsx, .xls or .csv file · accepts columns: pnl, mae, mfe.",
    bootstrap_placeholder: "127\n-340\n892\n-45\n-210\n...\n\nor:\ndate,pnl,mae\n2024-01-02,127,85\n2024-01-03,-340,420",
    bootstrap_parse: "parse data",
    bootstrap_paste_clip: "paste from clipboard",
    bootstrap_load_example: "◇ load example",
    bootstrap_upload_file: "↑ upload file",
    bootstrap_clear: "↺ clear",
    bootstrap_loading: "Processing...",
    bootstrap_drop_here: "Drop file here",
    bootstrap_error_format: "Unsupported format. Upload a .xlsx, .xls or .csv file.",
    bootstrap_error_parse: "Could not read the file. Make sure it's valid.",
    bootstrap_error_empty: "The file is empty or has no valid data.",
    bootstrap_excel_select_columns_title: "Assign columns",
    bootstrap_excel_sheet: "sheet",
    bootstrap_excel_column: "Column",
    bootstrap_excel_select_placeholder: "— Select a column —",
    bootstrap_excel_select_none: "— I don't have this column —",
    bootstrap_excel_preview: "Preview",
    bootstrap_excel_first_rows: "first rows",
    bootstrap_excel_confirm: "Confirm",
    bootstrap_excel_cancel: "Cancel",
    bootstrap_excel_label_pnl: "P&L column",
    bootstrap_excel_help_pnl: "Daily gain or loss (positive if winning, negative if losing).",
    bootstrap_excel_label_mae: "MAE column",
    bootstrap_excel_help_mae: "Maximum Adverse Excursion: the worst unrealized loss you had intraday before closing the trade.",
    bootstrap_excel_label_mfe: "MFE column",
    bootstrap_excel_help_mfe: "Maximum Favorable Excursion: the best unrealized gain you had intraday before closing the trade.",
    bootstrap_excel_too_few_values: "Only {count} numeric values found. Recommended minimum: 30.",
    optional: "optional",
    bootstrap_summary_title: "DATA SUMMARY",
    bootstrap_min_warning: "recommend ≥ 100 · you have fewer samples. results will be noisy.",
    boot_no_mae_warning: "Your data has no MAE column. Intraday excursions are estimated from your PnL distribution. For best accuracy with intraday drawdown rules, include a MAE column.",
    boot_preview_values: "First parsed values: {values}",
    survive_out_of_horizon: "Simulated horizon is shorter than this window. Increase the post-pass horizon to measure it.",

    mae_help: "MAE = maximum unrealized loss during the day before closing.",
    mae_estimate: "ESTIMATE (from instrument)",
    mae_manual: "MANUAL (direct values)",
    mae_auto: "AUTO (from bootstrap MAE column)",
    mae_auto_ok: "MAE read directly from your bootstrap data.",
    field_instrument: "instrument",
    field_mae_win_mean:  "μ MAE win",
    field_mae_win_std:   "σ MAE win",
    field_mae_loss_mean: "μ MAE loss",
    field_mae_loss_std:  "σ MAE loss",

    costs_help: "commissions erode net P&L. apply them if your P&Ls are gross (pre-fees).",
    costs_none: "NONE (P&L already net)",
    costs_estimate: "ESTIMATE (per contract × trades/day)",
    costs_fixed: "FIXED DAILY (flat amount)",
    field_comm_per_rt: "commission per R/T",
    field_trades_day:  "trades per day",
    field_contracts_trade: "contracts per trade",
    field_daily_commission: "daily commission",

    behav_post_title: "POST-TARGET BEHAVIOR",
    behav_conservative: "CONSERVATIVE (realistic)",
    behav_conservative_sub: "on hitting target, if consistency blocks pass, reduce size to 30% to dilute without risk.",
    behav_aggressive: "AGGRESSIVE (maximize speed)",
    behav_aggressive_sub: "keeps full size until pass. faster but more failures.",
    behav_mindays_title: "MIN DAYS COUNT",
    behav_mindays_total: "TOTAL TRADING DAYS",
    behav_mindays_winning: "WINNING DAYS ONLY (≥ $X)",
    field_win_day_threshold: "winning-day min $",
    behav_maxdays_title: "MAX DAYS TYPE",
    behav_maxdays_trading: "TRADING DAYS (~21/month)",
    behav_maxdays_calendar: "CALENDAR DAYS (Apex)",

    chart_attempt_curve: "ATTEMPT CURVE · p(≥1 pass) vs number of attempts",
    chart_commission_impact: "COMMISSION IMPACT",
    comm_daily: "daily cost",
    comm_per_attempt: "per attempt",
    comm_pct_target: "% of target",

    // Glossary new sections (EN)
    gloss_g_title: "FUNDED LIFECYCLE",
    gloss_h_title: "OPERATIONS",
    gloss_attempt_curve_name: "ATTEMPT CURVE",
    gloss_attempt_curve_body: "cumulative probability of at least one pass after N attempts. if individual P(PASS) is 30%, at the 5th attempt p(≥1 pass) is 83%; at the 10th, 97%. useful for sizing bankroll at 50%, 75%, 95%, 99% confidence.",
    gloss_funded_name: "FUNDED ACCOUNT",
    gloss_funded_body: "the live account you get after passing. typically inherits the eval DD rules (but not always). your only post-PASS goal is to compound profit without failing and take payouts when the firm's conditions are met. if you breach DD, you lose the account and pay an activation/reset fee if the firm allows it.",
    gloss_payout_name: "PAYOUT",
    gloss_payout_body: "withdrawal of accumulated profit from the funded account. each firm defines its conditions: minimum trading days, minimum profit, cadence between withdrawals. the trader receives the profit-split share (typically 80-90%). on most firms the balance resets to base capital after each payout.",
    gloss_takehome_name: "TAKE-HOME LIFETIME",
    gloss_takehome_body: "total net money you expect to extract over the useful life of a funded account before it's claimed by DD. this is the metric that really matters — P(PASS) is only the first step. an account with P(PASS)=30% and 4 expected payouts before burning out is much better than one with P(PASS)=50% but only 1 average payout.",
    gloss_commissions_name: "COMMISSIONS",
    gloss_commissions_body: "commissions erode your net P&L every day. for NQ/ES futures ~$4 round-trip, CL ~$5, forex near zero. if your backtest P&Ls are gross (before fees), apply them here — they can eat 10–25% of target for active scalpers. if they are already net, leave it on NONE.",
    gloss_behavioral_name: "BEHAVIORAL MODEL",
    gloss_behavioral_body: "models how the trader reacts when challenge rules make PASS harder. conservative reduces size to 30% if target is reached but consistency blocks — dilutes without risk. aggressive keeps full size and eats more DDs. calendar-days adds weekends to the timer (Apex), affecting TIMEOUTs.",
    gloss_autocorr_name: "AUTOCORRELATION WARNING",
    gloss_autocorr_body: "if your bootstrap data has high autocorrelation (|ρ| > 0.2), consecutive days are not independent (streaks). the simulator samples at random — it breaks those streaks. results may be too optimistic or pessimistic depending on the sign. in practice, a ρ between -0.1 and +0.1 is ideal.",

    // ─── POST-PASS (FUNDED CYCLE) · EN ───
    section_postpass: "POST-PASS · FUNDED CYCLE",
    postpass_toggle: "Simulate post-PASS cycle (funded account + payouts)",
    postpass_toggle_hint: "when PASS, we keep simulating the funded account until breach or horizon. extracts payouts per the firm's rules.",
    postpass_horizon: "Horizon (months)",
    postpass_horizon_hint: "simulation window in trading months (~21d/mo).",
    postpass_size_title: "POST-PASS SIZE",
    postpass_size_same: "SAME SIZE (pure realism)",
    postpass_size_same_sub: "same distribution as eval · the trader keeps their style.",
    postpass_size_reduced: "REDUCED (conservative)",
    postpass_size_reduced_sub: "apply a factor to size after funding — dilutes risk at the cost of speed.",
    postpass_size_factor: "Size factor",
    postpass_rules_title: "FUNDED ACCOUNT RULES",
    postpass_rules_hint: "pre-loaded per firm · you can override anything.",
    pp_firstPayoutMinDays: "First payout (min days)",
    pp_payoutFrequency:    "Between payouts (days)",
    pp_payoutBuffer:       "Safety buffer ($)",
    pp_payoutMinAmount:    "Min payout ($)",
    pp_payoutMaxPct:       "Withdrawable % (0–1)",
    pp_payoutMaxCap:       "Per-payout cap ($, optional)",
    pp_safetyNet:          "Safety net ($)",
    pp_payoutConsistency:  "Post-pass consistency (0–1)",
    pp_payoutConsistencyType: "Consistency type post-pass",
    pp_resetOnPayout:      "Reset balance after payout",
    pp_resetFloorOnPayout: "Reset floor after payout",
    pp_ddTypeOverride:     "DD type override",
    pp_ddValueOverride:    "DD value override ($)",
    pp_floorLockOverride:  "Floor-lock override",
    pp_dailyLossOverride:  "DLL override ($, optional)",
    postpass_reset: "Reset to firm defaults",

    oracle_funded_title: "FUNDED LIFECYCLE · post-PASS",
    oracle_funded_hint:  "assuming you pass the eval, how much money do you net and how long do you survive?",
    kpi_pp_expected_net: "EXPECTED NET",
    kpi_pp_expected_net_sub: "after profit split, horizon {h}m.",
    kpi_pp_payouts: "MEAN PAYOUTS",
    kpi_pp_payouts_sub: "withdrawals completed within horizon.",
    kpi_pp_first_payout: "TIME TO 1ST PAYOUT",
    kpi_pp_first_payout_sub: "median in trading days.",
    kpi_pp_survive3: "NO BREACH · 3M",
    kpi_pp_survive6: "NO BREACH · 6M",
    kpi_pp_survive12: "NO BREACH · 12M",
    // Phase 14 · Block 1d: median hero + at-least-one payout
    kpi_pp_typical_outcome: "TYPICAL OUTCOME (MEDIAN)",
    kpi_pp_mean_inflated: "mean (inflated by the right tail): {x}",
    kpi_pp_at_least_one: "P(≥1 PAYOUT)",
    kpi_pp_at_least_one_sub: "probability of cashing out at least once.",
    kpi_pp_at_least_one_tooltip: "Probability of completing at least one withdrawal before breach or horizon end.",
    // Phase 14 · Block 1a: seed UI
    seed_label: "seed",
    seed_rerun: "↺ new seed",
    seed_tooltip: "Same seed + same configuration = identical results. Change the seed to see another draw of randomness.",
    // Phase 14 · Block 3: block bootstrap UI
    block_sampling_notice: "sampling: ~{L}-day blocks (your streaks are preserved)",
    block_sampling_force_iid: "force independent days",

    // Phase 14 · Block 4: Strategy Lab
    lab_title: "STRATEGY LAB",
    lab_empty: "Load your real track record to analyze your strategy.",
    lab_computing: "Analyzing your strategy…",
    lab_section_edge: "Edge",
    lab_section_risk: "Risk",
    lab_section_growth: "Growth",
    lab_section_robust: "Robustness",
    lab_expectancy: "expectancy/day",
    lab_significance: "verdict",
    lab_edge_real: "Statistically real edge (p={p})",
    lab_edge_luck: "With {n} days, your edge is indistinguishable from luck (p={p})",
    lab_sqn_tooltip: "System Quality Number (Van Tharp): <1.6 poor · 1.6-2 average · 2-3 good · >3 excellent.",
    lab_sqn_poor: "poor",
    lab_sqn_average: "average",
    lab_sqn_good: "good",
    lab_sqn_excellent: "excellent",
    lab_worst_streak: "worst streak (days)",
    lab_streak_sub: "p50 · p90",
    lab_streak_tooltip: "Knowing this in advance is the difference between sticking to your system and quitting right before it pays.",
    lab_underwater: "time underwater",
    lab_underwater_sub: "% of days below the last peak",
    lab_kelly_advice: "Risk at most ~{f}% of your capital per average losing day",
    lab_kelly_no_edge: "no edge",
    lab_kelly_tooltip: "Full Kelly is aggressive; half Kelly or less is the prudent choice. If it comes out ≤0, there's no edge to bet on.",
    lab_split_ok: "Your two halves are consistent",
    lab_split_flag: "⚠ Your first and second halves look like different strategies (regime or system change?)",
    lab_conc_ok: "Your edge doesn't hinge on 3 lucky days ({x} without the top 3)",
    lab_conc_flag: "⚠ Without your 3 best days, your strategy loses money ({x})",

    // Phase 14 · Block 5: Sizing sweep
    sizing_title: "Optimal sizing · size curve",
    sizing_desc: "Same history, different sizes. Too small and you don't reach the target; too big and the drawdown executes you. There's a real optimum — and it depends on the firm.",
    sizing_run: "Run sizing sweep",
    sizing_running: "Computing 7 scenarios…",
    sizing_only_bootstrap: "Available only in bootstrap mode (your data).",
    sizing_current_label: "your current size (1×)",
    sizing_summary_html: "Your EV-optimal point: <strong>{k}× your historical size</strong> (P·PASS {p}%, EV {ev}). At 1×: P·PASS {p1}%.",
    sizing_disclaimer: "assumes linear PnL scaling with size (valid for moderate multipliers)",
    sizing_tooltip: "Assumes your PnL scales linearly with size — valid for moderate multipliers; large sizes break linearity via slippage.",

    // Phase 14 · Block 6: CRN compare note
    compare_crn_note: "comparison under identical randomness (CRN) — differences come from the rules alone · seed {n}",

    // Phase 14 · Block 7: Compatible firms
    compat_title: "FIRMS COMPATIBLE WITH YOUR STRATEGY",
    compat_tooltip: "We compare each plan's drawdown limit with the distribution of max DD that YOUR strategy generates in 30 days (at your current size). Green doesn't guarantee passing — it guarantees the limit isn't too small for you.",
    compat_green: "room at the 90th pct",
    compat_amber: "tight: room only at the 50th pct",
    // Phase 14 · Block 8: Guide entry links
    footer_guide_link: "User guide",
    help_guide_banner: "First time with Prop Forge? There's a step-by-step 10-minute guide.",
    help_guide_cta: "Read guide",

    compat_red: "your typical DD exceeds its limit",
    kpi_pp_lifetime_ev: "EV · FULL CYCLE",
    kpi_pp_lifetime_ev_tooltip: "Realized expected value with simulated payouts over the horizon: P(PASS) × mean extracted net − average cost. Differs from EV · EVAL because it includes multiple withdrawals before breach.",
    kpi_pp_lifetime_ev_sub: "P(PASS) × expected net − avg cost.",
    kpi_pp_breach_dd: "DD breach",
    kpi_pp_breach_dll: "DLL breach",
    kpi_pp_no_breach: "no breach",
    kpi_pp_p10p90: "p10 / p90 net",
    chart_pp_payout_hist: "TOTAL NET DISTRIBUTION ($)",
    chart_pp_payout_count: "PAYOUT COUNT DISTRIBUTION",
    chart_pp_by_month: "MEAN NET BY MONTH",
    oracle_pp_empty: "Enable 'POST-PASS · FUNDED CYCLE' in STRATEGY to see these metrics.",

    gloss_postpass_name: "POST-PASS CYCLE",
    gloss_postpass_body: "once the eval is passed, the funded account keeps DD/DLL rules active. the simulator projects N months, applies payouts per firm cadence, and checks whether DD takes you out before the horizon. key metrics: expected NET (after split), payout count, P(survive) at 3/6/12m, breach-rate.",
    gloss_safetynet_name: "SAFETY NET",
    gloss_safetynet_body: "amount of profit you must accumulate before unrestricted withdrawals (Apex-style). until reached, payouts are capped.",
    gloss_consistency_postpass_name: "POST-PASS CONSISTENCY",
    gloss_consistency_postpass_body: "some firms apply a consistency rule on the funded account (Topstep 50%, MFFU 40%, TPT 20%). if you violate it, you cannot withdraw — even if profit is available.",

    // IGNITE button disabled-state hints
    hint_no_chamber:       "first select a firm and an account in the firms tab",
    hint_bootstrap_empty:  "bootstrap mode active · paste your backtest data in the P&L section",
    hint_bootstrap_too_few:"need at least 30 values · you have {n}",

    // Extra glossary terms
    gloss_winning_days_name: "WINNING DAYS",
    gloss_winning_days_body: "when a firm requires a minimum number of trading days, they can either count ALL days (total) or only winning days (≥ $X). the 'WINNING DAYS ONLY' mode ignores flat/losing days, which typically lengthens the path to PASS but better reflects what some firms internally require to validate the account.\n\nexample: minDays=5 with winning-days mode and $50 threshold → you need 5 days with pnl ≥ $50, not just 5 trading days.",
    gloss_calendar_days_name: "CALENDAR vs TRADING DAYS",
    gloss_calendar_days_body: "the max-days counter can be measured in trading days (~21/mo, weekends ignored) or in calendar days (includes weekends). Apex uses CALENDAR — stricter. FTMO uses TRADING — more lenient.\n\nexample FTMO 100K (max 30 trading days) vs Apex 50K EOD (max 30 calendar days): the number is identical (30), but Apex gives you ~21 actual tradable days, while FTMO gives you ~42 natural days to complete the 30 tradable ones.",

    // Auth
    auth_sign_in: "sign in",
    auth_sign_up: "sign up",
    auth_sign_out: "log out",
    auth_email: "email",
    auth_password: "password",
    auth_password_hint: "minimum 6 characters",
    auth_submit_signin: "enter",
    auth_submit_signup: "create account",
    auth_switch_to_signup: "no account? sign up",
    auth_switch_to_signin: "already have an account? sign in",

    auth_check_email_title: "Check your email",
    auth_check_email_body_1: "We've sent a confirmation email to {email}.",
    auth_check_email_body_2: "Click the link in the email to activate your account. If you can't find it, check your spam or promotions folder.",
    auth_check_email_close: "Got it",
    auth_error_invalid_email: "invalid email",
    auth_error_short_password: "password must be at least 6 characters",

    // Paywall
    paywall_pro_feature: "pro feature",
    paywall_current_plan: "your plan: {plan}",
    paywall_upgrade_cta: "unlock",
    paywall_free_badge: "free",
    paywall_pro_badge: "pro",
    paywall_annual_badge: "annual",
    paywall_locked_firm: "firm locked on free plan",
    paywall_upgrade_modal_title: "unlock prop forge",
    paywall_upgrade_modal_body: "the pro plan unlocks all 22 firms, the business simulator, bootstrap mode, export, compare and more",
    paywall_upgrade_monthly: "pro · €31/month",
    paywall_upgrade_annual: "Annual · €199/year",
    paywall_period_yearly: "/year",
    paywall_close: "close",

    // Coming soon (UpgradeModal footer)
    coming_soon_title: "Coming soon",
    coming_lab_title: "Strategy Lab",
    coming_lab_desc: "Design and backtest your strategy with historical data. Integrated with Prop Forge.",
    coming_templates_title: "TradingView templates",
    coming_templates_desc: "Ready-made Pinescript: VWAP reclaim, NY open breakout, opening range...",
    coming_save_title: "Save configurations",
    coming_save_desc: "Save and share your favorite simulations with a link.",
    coming_mobile_title: "Mobile app",
    coming_mobile_desc: "Check probabilities from your phone. Push notifications.",
    coming_soon_footer: "Pro and Annual plans include access to all these features when launched.",

    // Stripe
    stripe_success_title: "Payment received!",
    stripe_success_body: "Welcome to {plan}. Unlocking your features...",
    stripe_cancel_title: "Checkout cancelled",
    stripe_cancel_body: "No charge was made.",
    manage_subscription: "manage subscription",
    stripe_loading: "processing payment...",
    stripe_error: "error processing · please try again",

    // Legal
    legal_terms: "terms",
    legal_privacy: "privacy",
    legal_cookies: "cookies",
    legal_last_updated: "last updated",
    legal_back_to_app: "← back to app",

    // Landing page
    landing_hero_title: "Calculate your real probability of passing a prop firm challenge",
    landing_hero_subtitle: "Monte Carlo simulation based on your real trading data. 22 firms, 81 accounts, no magic assumptions. Plus a business simulator to see many accounts at once.",
    landing_hero_cta: "Calculate my probability",
    landing_hero_subhint: "Free to start · no credit card required",

    landing_how_title: "How it works",
    landing_step_1_title: "Pick your prop firm",
    landing_step_1_desc: "22 firms with their exact rules (Apex, Topstep, Tradeify, Lucid, TakeProfit, FTMO, FundedNext…), the main futures firms audited in Sep 2026.",
    landing_step_2_title: "Paste your trading data",
    landing_step_2_desc: "A csv with your daily P&L history, or your backtest stats (win rate, average win/loss).",
    landing_step_3_title: "Get your probability",
    landing_step_3_desc: "P(PASS), expected value per attempt, required bankroll and average days to pass.",

    landing_pricing_title: "Simple pricing",
    landing_pricing_subtitle: "Start free. Pay only if it brings you value.",
    landing_price_forever: "Forever",
    landing_price_monthly: "/month",
    landing_price_one_time: "One-time",
    landing_free_feat_1: "3 firms (Topstep, Phidias, FundingPips)",
    landing_free_feat_2: "Data mode and summary stats mode",
    landing_free_feat_3: "Basic results: P(PASS), EV",
    landing_free_cta: "Start free",
    landing_pro_feat_1: "All 22 firms, 81 accounts · rules audited Sep 2026",
    landing_pro_feat_2: "Custom config · define your own rules",
    landing_pro_feat_3: "Multi-account business simulator + mix optimizer",
    landing_pro_feat_4: "Compare up to 4 plans at once",
    landing_pro_feat_5: "Export results (json, png)",
    landing_pro_feat_6: "Save up to 10 configurations",
    landing_pro_cta: "Choose Pro",
    landing_price_yearly: "/year",
    landing_annual_feat_1: "Everything in Pro",
    landing_annual_feat_2: "Up to 100 saved configurations",
    landing_annual_feat_3: "Access to future features when launched",
    landing_annual_cta: "Choose Annual",

    landing_faq_title: "Frequently asked questions",
    landing_faq_what_q: "What is Prop Forge?",
    landing_faq_what_a: "A Monte Carlo simulation tool that estimates your real probability of passing a prop firm challenge. You enter your real trading data or backtest stats, pick the firm, and we simulate 10,000 day-by-day attempts using the exact rules of that firm.",
    landing_faq_diff_q: "How is it different from other tools?",
    landing_faq_diff_a: "Most online calculators give you binary answers or oversimplified simulations. Prop Forge uses the bootstrap model (with your literal data) or the full Gaussian model, applies the exact rules of each firm (trailing drawdown, consistency rules, min/max days, fatal dlls, etc.), and gives you rigorous statistical results: P(PASS), expected value, required bankroll.",
    landing_faq_experience_q: "Do I need experience to use it?",
    landing_faq_experience_a: "No. If you've never done a backtest, you can use the 'load example' button to load 200 days of example data and see how it works. Each parameter has a contextual explanation on hover, and there's a complete glossary in the Help tab. That said, the results are only as good as the data you input.",
    landing_faq_security_q: "Is my data safe?",
    landing_faq_security_a: "Yes. Your trading data never leaves your browser until you choose to save it. Passwords are stored hashed (we don't see them), payments are processed by Stripe (we don't store cards), and the database is encrypted in MongoDB Atlas. Check our privacy policy for details.",
    landing_faq_cancel_q: "Can I cancel my subscription?",
    landing_faq_cancel_a: "Yes, at any time from the customer portal (inside the app). Cancellation is immediate and the next billing won't be charged. You keep access until the end of the paid period.",
    landing_faq_refund_q: "Are there refunds?",
    landing_faq_refund_a: "Since it's a digital product with immediate access, we don't offer refunds by default. That said, if you have a technical issue that prevents you from using the product, contact us and we'll resolve it. See full terms for details.",

    landing_finalcta_title: "Stop guessing",
    landing_finalcta_subtitle: "Calculate your real probability before paying for the next challenge.",
    landing_finalcta_button: "Start free",

    // ─── Phase 13 — Result confidence (CI on P(PASS)) ───
    ci_label: "Result confidence",
    ci_value: "90% CI: {low} – {high}",
    ci_computing: "Computing result confidence…",
    ci_narrow: "Solid estimate",
    ci_medium: "Indicative estimate — more data would sharpen it",
    ci_wide: "Small dataset: treat the central number with caution",
    ci_tooltip: "Your P(PASS) is estimated from {n} days of data. We resampled your data {b} times and recomputed the full analysis with each version: 90% of the results fall in this range. More data → narrower range → more reliability.",

    // ─── Phase 13 — Degradation stress test ───
    stress_title: "Stress test · degradation margin",
    stress_desc: "Your track record reflects normal-conditions execution. Under pressure, execution worsens. This matrix shows how much your EV withstands if your win rate erodes or your losses grow.",
    stress_run: "Run stress test",
    stress_running: "Running {n} scenarios…",
    stress_rows_label: "Win-rate erosion",
    stress_cols_label: "Loss amplification",
    stress_margin: "WR margin: up to −{wr} pp · Loss margin: up to +{loss}%",
    stress_margin_inf_wr: "Your EV withstands the full tested WR erosion (−7.5 pp)",
    stress_margin_inf_loss: "Your EV withstands the full tested amplification (+30%)",
    stress_margin_zero: "No margin: your EV is already at the limit without degradation",
    stress_na: "N/A",
    stress_tooltip: "WR erosion: we convert part of your winning days into real losing days from your own history. Loss amplification: each losing day loses {pct}% more (worse stop execution). EV recomputed with {sims} simulations per cell.",
    stress_only_bootstrap: "Available only in bootstrap mode (your data).",
    // ─── Sep 2026 · business simulator + audited rules ───
    biz_nav: "Business",
    biz_new: "new",
    biz_kicker: "◆ · business",
    biz_title: "Business simulator",
    biz_hint: "Your strategy running several accounts at once on a limited bankroll: you buy evals, get paid, reinvest and replace blown accounts. What a single-account sim can't tell you.",
    biz_empty_title: "Load your strategy in step ② first. The business simulator uses exactly the same data.",
    biz_empty_cta: "Go to strategy →",
    biz_sec_mix: "Account mix",
    biz_mix_desc: "Which evaluations you buy. They are bought in turns while there is cash and room under each firm's cap.",
    biz_presets: "Examples:",
    biz_preset_diversified: "Diversified · 4 firms",
    biz_preset_apex_only: "Apex 50K only",
    biz_preset_cheap_entry: "Cheap entry · 25K",
    biz_add_firm: "Firm",
    biz_add_plan: "Account",
    biz_add_btn: "+ Add",
    biz_size: "× size",
    biz_remove: "Remove",
    biz_mix_empty: "Add at least one account or load an example.",
    biz_mix_full: "Up to {n} accounts in the mix.",
    biz_caps_title: "Max simultaneous funded accounts per firm",
    biz_col_eval: "Eval",
    biz_col_funded: "How it pays",
    biz_per_month: "/mo",
    biz_plus_act: "+ {x} activation",
    biz_rules_old: "Apr-26 rules",
    biz_sec_capital: "Capital & business rules",
    biz_bankroll: "Starting bankroll",
    biz_horizon: "Horizon (months)",
    biz_reinvest: "Reinvest share of each payout",
    biz_parallel: "All accounts trade from",
    biz_slots: "Funded trading per day before",
    biz_cushion: "Cash cushion",
    biz_daycap: "Daily profit cap per account",
    biz_corr: "Correlation between accounts",
    biz_corr_copy: "Copy-trading",
    biz_corr_indep: "Independent",
    biz_resets: "Use funded resets",
    biz_promos: "Apply current promos",
    biz_vat: "EU resident (VAT)",
    biz_nsims: "Simulations",
    biz_run: "Simulate business",
    biz_running: "Simulating…",
    biz_res_title: "Business outcome",
    biz_res_meta: "{n} simulated years · seed {s} · {m} months",
    biz_new_seed: "↻ new seed",
    biz_kpi_profit: "Median profit",
    biz_kpi_profit_sub: "net of evals, activations and resets · mean {x}",
    biz_kpi_ruin: "Ruin",
    biz_kpi_ruin_sub: "no accounts left and no cash for another eval · ±{ci}",
    biz_kpi_p10: "Bad decile (p10)",
    biz_kpi_p10_sub: "1 in 10 years ends worse than this",
    biz_kpi_loss: "End in the red",
    biz_kpi_loss_sub: "less money than the starting bankroll",
    biz_kpi_first: "1st payout",
    biz_kpi_first_sub: "median day · {p} of years with no payout",
    biz_kpi_payouts: "Payouts",
    biz_kpi_payouts_sub: "median over the horizon",
    biz_kpi_evals: "Evals bought",
    biz_kpi_evals_sub: "{x} on evals, activations and resets",
    biz_kpi_peak: "Peak funded",
    biz_kpi_peak_sub: "p90: {x} at once",
    biz_kpi_pocket: "To your pocket",
    biz_kpi_pocket_sub: "non-reinvested share (median)",
    biz_kpi_scale: "Scale-up",
    biz_kpi_scale_sub: "median day · {p} of years get there",
    biz_kpi_scale_none: "not reached",
    biz_chart_fan: "Business net worth (cash + withdrawn)",
    biz_chart_fan_cap: "p10–p90 and p25–p75 bands · line = median · red = starting bankroll",
    biz_chart_hist: "Profit distribution",
    biz_chart_hist_cap: "% of simulated years · line = median",
    biz_axis_day: "trading day",
    biz_table_title: "What each account contributes",
    biz_th_account: "Account",
    biz_th_bought: "Evals",
    biz_th_pass: "Pass %",
    biz_th_payouts: "Payouts",
    biz_th_net: "Net paid",
    biz_th_breaches: "Blown",
    biz_th_grad: "Graduated",
    biz_table_note: "Means per simulated year. “Graduated” = completed the firm's payout cycles (moves to live / Elite) and is no longer simulated.",
    biz_robust_title: "What if your edge is smaller?",
    biz_robust_desc: "Same mix, subtracting 10% and 25% of your mean daily profit from every day. If the business only works with the exact historical edge, it is fragile.",
    biz_robust_base: "Historical edge",
    biz_robust_row: "Edge −{x}%",
    biz_robust_computing: "computing…",
    biz_th_profit: "Profit p50",
    biz_th_ruin: "Ruin",
    biz_th_p10: "p10",
    biz_cash_warn: "Median minimum cash: {x}. The plan runs on fumes: a week without cash to activate a passed account can cost you that account. Raise the cushion or trim the mix.",
    biz_load_warn: "Operational load: up to {x} funded accounts at once. That is a daily job (trading, payouts, consistency, reactivations).",
    biz_warn_title: "What the model does NOT see",
    biz_warn_1: "Payout delays and reviews, news blackouts and firm rule changes.",
    biz_warn_2: "Copy-trading failures and different slippage between accounts.",
    biz_warn_3: "Market regimes missing from your history: bootstrap only reshuffles the past.",
    biz_warn_4: "Purchase limits (e.g. evals per month) and account review pauses.",
    biz_opt_title: "Mix optimizer",
    biz_opt_desc: "Tries every combination of up to {k} accounts from your mix with the same seed (only the rules change), then validates the best ones with more sims and with your edge 10% worse.",
    biz_opt_maxk: "Accounts per mix (max)",
    biz_opt_maxruin: "Max acceptable ruin",
    biz_opt_run: "Find the best mix · {n} combinations",
    biz_opt_cancel: "Cancel",
    biz_opt_phase_screen: "testing combinations",
    biz_opt_phase_validate: "validating finalists",
    biz_opt_frontier: "Profit–ruin frontier",
    biz_opt_frontier_cap: "each dot is a mix ({n} sims) · gold = efficient frontier · red = your ruin limit",
    biz_opt_finalists: "Validated finalists ({n} sims)",
    biz_th_mix: "Mix",
    biz_th_stress: "Edge −10%",
    biz_th_first: "1st payout",
    biz_opt_load: "Use",
    biz_opt_bias: "Winner's bias: when you keep the best of {n} mixes, its real expected result is lower than shown. Pick with a margin using the frontier and the “Edge −10%” column, not the top row blindly.",
    biz_opt_need2: "Add at least 2 accounts to the mix to optimize.",
    biz_opt_locked: "The mix optimizer is a PRO feature.",
    biz_opt_none_ok: "No mix meets your ruin limit: showing the lowest-ruin ones.",
    biz_principles_title: "Principles that tend to hold",
    biz_principles_note: "Check them with YOUR data in the simulator: they all depend on the strategy.",
    biz_pr_1: "Bigger evals usually pay more per dollar: the target scales with size, the price not as much, and payout caps are higher.",
    biz_pr_2: "Fixed size beats dynamic size: sizing up after a streak concentrates risk exactly when you have the most accounts exposed.",
    biz_pr_3: "Don't reinvest 100%: what you withdraw can't be lost again. 20% to your pocket barely slows growth and lowers ruin.",
    biz_pr_4: "Diversify firms, not just accounts: with copy-trading they all fall on the same day; different rules don't break for the same reason at once.",
    biz_pr_5: "Don't spend your last dollar on evals: without cash to activate a passed account, you can lose it.",
    biz_pr_6: "Starting at 25K to “scale later” is usually worse: more evals, low payout caps and the same ruin risk.",
    biz_audit_note: "Rules audited in Sep 2026 on the official sites: Apex PA, Tradeify, Lucid, TakeProfit and Topstep 50K. Plans tagged “Apr-26 rules” were not re-audited.",
    biz_tease: "Unlock the full outcome: profit, ruin, net-worth fan and mix optimizer.",
    biz_error: "Simulation failed: {e}",
    audit_badge_recent: "audited sep-26",
    audit_badge_old: "apr-26 rules",
    new_badge: "new",
    plan_max_micros: "max {n} micros",
    plan_promo: "promo {code}",
    plan_vat_note: "+EU VAT",
    funded_rules_label: "funded",
    hint_biz_ready: "Strategy loaded: try the business simulator to see several accounts at once.",
    gloss_i_title: "MULTI-ACCOUNT BUSINESS",
    gloss_biz_bankroll_name: "Business bankroll",
    gloss_biz_bankroll_body: "The money you start with to buy evaluations, activations and resets. It is never traded: the capital at risk in the market is the firm's. If it runs out with no live account left, the business is ruined.",
    gloss_biz_ruin_name: "Business ruin",
    gloss_biz_ruin_body: "Share of simulated years where you end with no live accounts and no cash to buy another eval. Not the same as losing an account: a healthy business loses accounts all the time and replaces them with what it earns.",
    gloss_biz_reinvest_name: "Reinvestment",
    gloss_biz_reinvest_body: "Share of each payout that goes back to cash to buy new evals. What is not reinvested goes to your pocket and can't be lost again; that is why reinvesting less than 100% lowers ruin.",
    gloss_biz_copy_name: "Copy-trading and correlation",
    gloss_biz_copy_body: "Replicating the same execution on every account. It multiplies payouts but also makes every account lose on the same day: with 20 copied accounts a bad day doesn't blow one account, it blows twenty. The simulator models this by default.",
    gloss_biz_caps_name: "Per-firm account cap",
    gloss_biz_caps_body: "Max simultaneous funded accounts a firm allows, across all its products (e.g. Apex 20, Tradeify 5 between Flex and Daily). It limits how far a business built on a single firm can grow.",
    gloss_biz_graduation_name: "Graduation (payout cycles)",
    gloss_biz_graduation_body: "Some firms cap payouts on the simulated funded account: Apex 6 cycles, Tradeify Flex 5, Lucid 4. After that the account moves to live / Elite with other rules. The simulator removes it from the business and frees its slot.",
    gloss_biz_bias_name: "Winner's bias",
    gloss_biz_bias_body: "If you test many combinations and keep the best one, part of its edge is sample luck. Its real expected result is lower than shown. That is why the optimizer re-validates finalists with more sims and a 10% weaker edge.",
  },
};

// ─── Long-form tooltips for complex concepts (ⓘ popovers) ───
export const TOOLTIPS = {
  es: {
    dd_type: {
      title: "Tipo de drawdown",
      body: "Define cómo se calcula el límite de pérdida:\n\n• trailing intraday → el límite sube con cada pico de equity no realizado · el más estricto\n• trailing eod → el límite solo sube con el cierre del día · más permisivo\n• static → el límite es fijo, nunca se mueve · el más permisivo",
    },
    floor_lock: {
      title: "Floor lock",
      body: "A partir de qué punto deja de subir el floor del trailing drawdown:\n\n• none → nunca se ancla · topstep eval\n• at_capital → se ancla al llegar al capital inicial · TPT, tradeday\n• at_target_level → se ancla al llegar a capital + target · apex\n• at_capital_plus_100 → se ancla en capital + $100 cuando EOD ≥ capital + DD + $100 · tradeify, fundednext",
    },
    consistency: {
      title: "Consistency rule",
      body: "Hay dos mecanismos distintos:\n\n• vs_target → si tu mejor día supera X% del target, el target EFECTIVO sube · no bloquea, endurece · topstep, TPT\n• vs_total → el pass se bloquea si tu mejor día > X% del profit acumulado · se desbloquea tradeando más días · MFFU, fundednext legacy, tradeday\n\nEj vs_target (topstep 50%, target 3000): ganas 2000 un día → target sube a 4000\nEj vs_total (MFFU 40%, target 3000): has ganado 3000 total con mejor día 1500 (50%) → no puedes pasar hasta diluir",
    },
    mae: {
      title: "MAE · Maximum Adverse Excursion",
      body: "El movimiento máximo adverso dentro del día antes de que cierres la posición.\n\nEj: terminas un día ganando +100 pero a media mañana ibas -300 · el MAE es 300.\n\nLos scales (0.24 win / 0.40 loss) calibran qué tan volátil es tu intradía respecto al cierre. Si tu estrategia es estable al cierre pero oscila mucho durante el día, sube los scales.",
    },
    dll: {
      title: "Daily Loss Limit",
      body: "Pérdida máxima permitida en un solo día.\n\n• Fatal (sí) → si la superas, la cuenta FALLA inmediatamente · FTMO, fundingpips, fundednext stellar\n• No fatal → pausa el trading el resto del día pero la cuenta sobrevive · apex EOD, earn2trade, the 5%ers, fundednext bolt",
    },
    phases: {
      title: "Número de fases",
      body: "• 1 fase → un solo nivel a superar · mayoría de futuros\n• 2 fases → fase 1 agresiva (target 10%) + fase 2 conservadora (target 5%) · FTMO, fundingpips, fundednext stellar · la equity se resetea al empezar fase 2 pero las reglas de DD siguen iguales",
    },
    ev: {
      title: "EV · EVAL (1 retiro)",
      body: "Valor esperado neto por intento asumiendo un único retiro al pasar: P(PASS) × (target final × profit split) − coste medio. Es una aproximación conservadora. Para el valor con ciclo completo de payouts, activa la simulación funded.",
    },
    bankroll: {
      title: "Bankroll 95%",
      body: "Cuánto dinero necesitas para tener un 95% de probabilidad de pasar al menos una vez antes de quedarte sin fondos.\n\nCálculo: n_intentos_necesarios × coste_medio_por_intento",
    },
    break_even: {
      title: "Break-even P(PASS)",
      body: "La probabilidad mínima de pasar para que la EV sea 0 o positiva.\n\nSi tu P(PASS) real > break-even → la firma es rentable para ti\nSi tu P(PASS) real < break-even → pierdes dinero a largo plazo",
    },
    wr: {
      title: "Win rate",
      body: "Fracción decimal · 0.37 = 37% de días ganadores.\n\nNota: esto es por DÍA, no por trade. Si operas varios trades/día, agrégalos en el P&L neto del día.",
    },
    mu_sigma: {
      title: "Μ y σ",
      body: "Μ (mu) = media · σ (sigma) = desviación típica.\n\nSe modela cada día como una distribución normal: N(μ, σ). Un día ganador típico tiene P&L ~μwin ± σwin.",
    },
    spike: {
      title: "Días outlier (spike)",
      body: "Con probabilidad p(spike) el P&L del día se multiplica por spike_mult para modelar colas gordas (noticias, slippage extremo, halts).\n\n0.0315 × 1.18 ≈ 3% de días con ~18% más de movimiento.",
    },
    capital: {
      title: "Capital inicial",
      body: "El balance con el que arranca la cuenta del challenge. Todos los cálculos de target, drawdown y daily-loss se expresan en relación a este número.",
    },
    target: {
      title: "Profit target",
      body: "Ganancia neta total que debes alcanzar para pasar el challenge. Expresada como cantidad fija (no porcentaje).",
    },
    dd_value: {
      title: "Drawdown · valor",
      body: "Valor en dólares del límite de drawdown. Depende del tipo (trailing eod, intraday o estático). Si tu equity baja del floor calculado, la cuenta falla.",
    },
    daily_loss: {
      title: "Daily loss limit (DLL)",
      body: "Máxima pérdida permitida en un solo día. Ver tooltip 'DLL' para detalle de fatal vs no fatal.",
    },
    consistency_pct: {
      title: "% de consistency",
      body: "Umbral en fracción decimal (0.50 = 50%). Interpreta según el tipo elegido (vs_target / vs_total).",
    },
    fee: {
      title: "Fee del challenge",
      body: "Coste de inscripción al challenge. Mensual (se renueva cada mes hasta pasar) o pago único.",
    },
    profit_split: {
      title: "Profit split",
      body: "Porcentaje de los profits que el trader recibe una vez funded. Típicamente 80–90% (a veces 100% en los primeros payouts).",
    },
    n_sims: {
      title: "Trayectorias",
      body: "Número de simulaciones monte carlo. Más trayectorias = resultados más estables, pero más lento. 10.000 suele ser suficiente.",
    },
    instrument: {
      title: "Instrumento",
      body: "Se usa solo para estimar el ratio MAE típico de ese mercado (NQ, ES, RTY, FX). Si tienes datos de MAE en tu CSV, usa modo AUTO en lugar de ESTIMATE.",
    },
    biz_bankroll: {
      title: "Bankroll inicial",
      body: "Dinero con el que arrancas el negocio. Solo sirve para comprar evals, activaciones y resets: si se acaba y no te queda ninguna cuenta viva, el negocio quiebra.",
    },
    biz_reinvest: {
      title: "Reinversión",
      body: "Qué parte de cada cobro vuelve a la caja para comprar evals nuevas. El resto va a tu bolsillo y ya no se puede perder.\n\n100% = máximo crecimiento y máxima ruina · 80% suele ser un buen equilibrio.",
    },
    biz_parallel: {
      title: "Paso a escala",
      body: "Mientras el patrimonio (caja + retirado) esté por debajo de esta cifra, solo operan unas pocas fondeadas al día, por turnos. Al superarla, TODAS operan cada día (copy-trading).\n\n0 = todas a la vez desde el principio.",
    },
    biz_slots: {
      title: "Fondeadas por día al arrancar",
      body: "Cuántas cuentas fondeadas operan cada día antes del paso a escala. Las demás esperan su turno. Menos cuentas expuestas el mismo día = menos riesgo de perderlas todas juntas.",
    },
    biz_cushion: {
      title: "Colchón de caja",
      body: "Dinero que nunca se gasta en evals nuevas. Sirve para pagar activaciones y renovaciones mensuales sin quedarte a cero.",
    },
    biz_daycap: {
      title: "Tope diario por cuenta",
      body: "Cuando una cuenta gana esta cifra en el día, deja de operar. Protege las reglas de consistencia (ningún día puede pesar demasiado) a cambio de recortar los días grandes.\n\n0 = sin tope.",
    },
    biz_corr: {
      title: "Correlación",
      body: "Copy-trading: todas las cuentas copian el mismo trade, así que ganan y pierden el mismo día · realista si replicas la ejecución.\n\nIndependientes: cada cuenta saca su propio día · solo realista con estrategias o horarios distintos. Suele dar una quiebra demasiado optimista.",
    },
    biz_size: {
      title: "Multiplicador de tamaño",
      body: "Tamaño de cada cuenta respecto al de tu historial. 1 = mismos contratos que en tus datos; 2 = el doble (P&L y MAE ×2). Respeta el máximo de micros de la firma.",
    },
    biz_caps: {
      title: "Tope por firma",
      body: "Máximo de cuentas fondeadas a la vez por firma, sumando TODOS sus productos (p. ej. Tradeify Flex + Daily comparten el mismo tope). Las evals en curso también ocupan hueco.",
    },
    biz_ruin: {
      title: "Quiebra del negocio",
      body: "% de años simulados en los que te quedas sin ninguna cuenta viva y sin caja para comprar otra eval. El ± es el intervalo de confianza del 95% por número de simulaciones.",
    },
  },
  en: {
    dd_type: {
      title: "Drawdown type",
      body: "Defines how the loss limit is calculated:\n\n• trailing intraday → limit rises with every unrealized equity peak · strictest\n• trailing eod → limit only rises on daily close · more forgiving\n• static → limit is fixed, never moves · most forgiving",
    },
    floor_lock: {
      title: "Floor lock",
      body: "At which point the trailing drawdown floor stops rising:\n\n• none → never anchors · topstep eval\n• at_capital → anchors at starting capital · TPT, tradeday\n• at_target_level → anchors at capital + target · apex\n• at_capital_plus_100 → anchors at capital + $100 once EOD ≥ capital + DD + $100 · tradeify, fundednext",
    },
    consistency: {
      title: "Consistency rule",
      body: "Two different mechanisms:\n\n• vs_target → if your best day exceeds X% of target, the EFFECTIVE target rises · doesn't block, hardens · topstep, TPT\n• vs_total → PASS is blocked if best day > X% of cumulative profit · unlocks by trading more days · MFFU, fundednext legacy, tradeday\n\nEx vs_target (topstep 50%, target 3000): you make 2000 one day → target rises to 4000\nEx vs_total (MFFU 40%, target 3000): you've made 3000 with best day 1500 (50%) → can't pass until diluted",
    },
    mae: {
      title: "MAE · Maximum Adverse Excursion",
      body: "The worst adverse move inside the day before you close the position.\n\nEx: you end a day +100 but went -300 mid-morning · MAE = 300.\n\nScales (0.24 win / 0.40 loss) calibrate how volatile your intraday is vs. The close. If your strategy is stable at close but swings a lot during the day, raise the scales.",
    },
    dll: {
      title: "Daily Loss Limit",
      body: "Max loss allowed in a single day.\n\n• Fatal (yes) → breach = account FAILS immediately · FTMO, fundingpips, fundednext stellar\n• Non-fatal → pauses trading for the rest of the day but the account survives · apex EOD, earn2trade, the 5%ers, fundednext bolt",
    },
    phases: {
      title: "Number of phases",
      body: "• 1 phase → single level · most futures firms\n• 2 phases → phase 1 aggressive (10% target) + phase 2 conservative (5% target) · FTMO, fundingpips, fundednext stellar · equity resets at phase 2 start but DD rules carry over",
    },
    ev: {
      title: "EV · EVAL (single payout)",
      body: "Net expected value per attempt assuming a single withdrawal on passing: P(PASS) × (final target × profit split) − average cost. A conservative approximation. For the full payout-cycle value, enable the funded simulation.",
    },
    bankroll: {
      title: "Bankroll 95%",
      body: "How much you need to have a 95% probability of passing at least once before running out of funds.\n\nCalc: n_attempts × avg_cost_per_attempt",
    },
    break_even: {
      title: "Break-even P(PASS)",
      body: "The minimum PASS probability for EV to be 0 or positive.\n\nIf your real P(PASS) > break-even → firm is profitable for you\nIf your real P(PASS) < break-even → loses money long-term",
    },
    wr: {
      title: "Win rate",
      body: "Decimal fraction · 0.37 = 37% winning days.\n\nNote: this is per DAY, not per trade. If you take multiple trades per day, aggregate into net daily P&L.",
    },
    mu_sigma: {
      title: "Μ and σ",
      body: "Μ (mu) = mean · σ (sigma) = standard deviation.\n\nEach day is modeled as a normal distribution: N(μ, σ). A typical winning day has P&L ~μwin ± σwin.",
    },
    spike: {
      title: "Outlier days (spike)",
      body: "With probability p(spike) the day's P&L is multiplied by spike_mult to model fat tails (news, extreme slippage, halts).\n\n0.0315 × 1.18 ≈ 3% of days with ~18% extra movement.",
    },
    capital: {
      title: "Starting capital",
      body: "The balance the challenge account starts with. Target, drawdown and daily-loss are all expressed in relation to this number.",
    },
    target: {
      title: "Profit target",
      body: "Total net profit needed to pass the challenge. Expressed as a dollar amount (not a percentage).",
    },
    dd_value: {
      title: "Drawdown · value",
      body: "Dollar value of the drawdown limit. Behaves differently depending on type (trailing eod, intraday or static). If equity dips below the floor, the account fails.",
    },
    daily_loss: {
      title: "Daily loss limit (DLL)",
      body: "Max loss allowed in a single day. See the 'DLL' tooltip for fatal vs non-fatal details.",
    },
    consistency_pct: {
      title: "Consistency %",
      body: "Threshold as a decimal fraction (0.50 = 50%). Interpretation depends on the chosen type (vs_target / vs_total).",
    },
    fee: {
      title: "Challenge fee",
      body: "Cost to enter the challenge. Monthly (renewed each month until pass) or one-time.",
    },
    profit_split: {
      title: "Profit split",
      body: "Percentage of profits the trader keeps once funded. Typically 80–90% (sometimes 100% on early payouts).",
    },
    n_sims: {
      title: "Paths",
      body: "Number of monte-carlo paths. More paths = more stable results, but slower. 10,000 is usually plenty.",
    },
    instrument: {
      title: "Instrument",
      body: "Used only to estimate the typical MAE ratio for that market (NQ, ES, RTY, FX). If your CSV has MAE columns, use AUTO mode instead of ESTIMATE.",
    },
    biz_bankroll: {
      title: "Starting bankroll",
      body: "The money the business starts with. It only pays for evals, activations and resets: if it runs out with no live account left, the business is ruined.",
    },
    biz_reinvest: {
      title: "Reinvestment",
      body: "Share of each payout that goes back to cash to buy new evals. The rest goes to your pocket and can't be lost again.\n\n100% = max growth and max ruin · 80% is usually a good balance.",
    },
    biz_parallel: {
      title: "Scale-up threshold",
      body: "While net worth (cash + withdrawn) is below this, only a few funded accounts trade each day, in turns. Above it, ALL of them trade every day (copy-trading).\n\n0 = all at once from day one.",
    },
    biz_slots: {
      title: "Funded per day at start",
      body: "How many funded accounts trade each day before scale-up. The rest wait their turn. Fewer accounts exposed on the same day = less risk of losing them all together.",
    },
    biz_cushion: {
      title: "Cash cushion",
      body: "Money never spent on new evals. It pays for activations and monthly renewals so you don't hit zero.",
    },
    biz_daycap: {
      title: "Daily cap per account",
      body: "Once an account makes this much in a day it stops trading. Protects consistency rules (no single day may weigh too much) at the cost of trimming big days.\n\n0 = no cap.",
    },
    biz_corr: {
      title: "Correlation",
      body: "Copy-trading: every account copies the same trade, so they win and lose on the same day · realistic if you replicate execution.\n\nIndependent: each account draws its own day · only realistic with different strategies or sessions. Usually too optimistic on ruin.",
    },
    biz_size: {
      title: "Size multiplier",
      body: "Size of each account relative to your history. 1 = same contracts as in your data; 2 = double (P&L and MAE ×2). Respect the firm's max micros.",
    },
    biz_caps: {
      title: "Per-firm cap",
      body: "Max funded accounts at once per firm, across ALL its products (e.g. Tradeify Flex + Daily share one cap). Running evals also take a slot.",
    },
    biz_ruin: {
      title: "Business ruin",
      body: "% of simulated years where you end with no live account and no cash for another eval. The ± is the 95% confidence interval from the number of simulations.",
    },
  },
};
